import {
    ChangeDetectorRef,
    Component,
    ComponentRef,
    ElementRef,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AnayticsConstants, Constants, DatapointsViewMode } from "src/app/constants";
import { Dataset } from "src/app/model/dataset/dataset";
import { DatasetService } from "src/app/data-access-layer/dataset/dataset.service";
import { OverlaysService } from "src/app/data-access-layer/global-overlays/overlays.service";
import { GroupService } from "src/app/data-access-layer/groups/group.service";
import { Subscription, forkJoin } from "rxjs";
import { TreeStructureUtils } from "src/app/core/utils/tree-structure-utils";
import { TreeNode, TreeStructure } from "src/app/model/menu/tree-structure";
import { DatapointsPageStateService } from "../datapoints/datapoints-page-state.service";
import { DatasetFieldType } from "src/app/model/dataset/dataset-field-type";
import { AccountService } from "src/app/data-access-layer/account/account.service";
import { WorkspaceItemService } from "src/app/data-access-layer/workspace-item/workspace-item.service";
import { WorkspaceItemType } from "src/app/model/workspace/workspace-item-type";
import { WorkspaceItem } from "src/app/model/workspace/workspace-item";
import { ReportType } from "src/app/model/analytics/report-type";
import { DatasetField } from "src/app/model/dataset/field/dataset-field";
import { LinkDatasetService } from "src/app/data-access-layer/dataset/link-dataset.service";
import { ReportRequest } from "src/app/model/datapoint/report/report-request";
import { AggregateGroupRequest } from "src/app/model/datapoint/report/aggregate-group-request";
import { DatapointAggregateFieldType } from "src/app/model/datapoint/report/datapoint-aggregate-field-type";
import { DatapointsAggregateService } from "src/app/data-access-layer/datapoints/datapoints-aggregate.service";
import { Aggregate } from "src/app/core/analytics/aggregate";
import { GroupTreeNode } from "src/app/model/overlay/group/group-with-overlays-tree-node";
import { ReportDisplayType } from "src/app/model/analytics/report-display-type";
import { ChartDisplayLabel, ChartDisplayType } from "src/app/model/analytics/chart-display-type";
import { DatasetFieldSpecificType } from "src/app/model/dataset/dataset-field-specific.type";
import { MatDialog } from "@angular/material/dialog";
import { Sort } from "@angular/material/sort";
import { OverlaysConstants } from "src/app/external-overlays/externaloverlays.constants";
import { Grouping } from "src/app/model/dataset/rendering/datapoint-converter-options";
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from "@angular/forms";
import { DatasetFieldFloatingOption } from "src/app/model/dataset/dataset-field-floating-option";
import { Count } from "src/app/core/analytics/count";
import { Ranking } from "src/app/core/analytics/ranking";
import { DatapointsService } from "src/app/data-access-layer/datapoints/datapoints.service";
import { DatasetFieldScope } from "src/app/model/dataset/dataset-field-scope";
import { TessadataNriFields } from "src/app/core/tessadata/tessadata-nri-fields";
import { decodeHtmlText, isNullOrUndefined, isUndefined } from "src/app/core/utils/util-master";
import { CustomScoringService } from "src/app/account/custom-scoring/services/custom-scoring.service";
import { CustomScoringScope } from "src/app/account/custom-scoring/model/custom-service";
import { WorkspaceItemDialogComponent } from "../workspace-item/projection/workspace-item-dialog.component";
import { getGroupsLocalStorageKey, UserStateService } from "src/app/auth/user-state-service";
import { WorkspaceItemAccess } from "src/app/model/workspace/workspace-item-access";
import { RandomUtils } from "src/app/core/utils/random-utils";
import { DownloadReportItem } from "src/app/model/download/item/download-report-item";
import { DownloadReportRequest } from "src/app/model/download/download-report-request";
import { DownloadDatapointRequest } from "src/app/model/download/download-datapoint-request";
import { AttachmentUtils } from "src/app/core/utils/attachment-utils";
import { DownloadService } from "src/app/data-access-layer/download/download.service";
import { NotifService } from "src/app/core/notification/notif.service";
import { DownloadFileType } from "src/app/model/download/download-file-type";
import { DialogModel } from "src/app/model/dialog/dialog-model";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";
import { take } from "rxjs/operators";
import { DownloadItemReportType } from "src/app/model/download/item/download-item-report-type";
import {
    CdkDragDrop,
    moveItemInArray,
} from "@angular/cdk/drag-drop";
import { SidePanelComponent } from "src/app/core/side-panel/side-panel.component";
import { SidePanelService } from "src/app/shared/services/side-panel.service";
import { SidePanels } from "src/app/shared/services/side-panel.helper";
import jsPDF from "jspdf";
import { DownloadReport } from "src/app/core/analytics/download-report";
import { ResizeEvent } from "angular-resizable-element";
import { UpdateWorkspaceItemStateRequest } from "src/app/model/workspace/workspace-item-sequence/update-workspace-item-state-request";
import { UpdateWorkspaceItemSequenceRequest } from "src/app/model/workspace/workspace-item-sequence/update-workspace-item-sequence-request.";
import { sequence } from "@angular/animations";
import { ObjectUtils } from "src/app/core/utils/object-utils";
import { DatasetUtils } from "src/app/core/utils/dataset-utils";
import { UpdateWorkspaceItemRequest } from "src/app/model/workspace/update-workspace-item-request";
import { IndicatorsEditDialog } from "./indicators-edit-dialog/indicators-edit-dialog.component";
import { DashboardService } from "src/app/data-access-layer/dataset/dashboard.service";
import { IndicatorField, IndicatorsData } from "src/app/model/dashboard/indicators-data";
import { StringUtils } from "src/app/core/utils/string-utils";
// import html2pdf from "html2pdf.js";
import { MaptycsApplication } from "src/app/model/account/maptycs-application";
import { DatasetGeometryType } from "src/app/model/dataset/dataset-geometry-type";
import { NumberFloatingFilter } from "ag-grid-community/dist/lib/filter/provided/number/numberFloatingFilter";
import { Datapoints } from "../datapoints/datapoints";
import { Group } from "src/app/model/group/group";
import { AnalyticsUtils } from "src/app/core/analytics/analytics-utils";
import { MatCheckboxChange } from "@angular/material/checkbox";

type AnalitycsComponentType = {
    dataset: Dataset;
    nriFields: any;
    isDashboardCall: boolean;
    climateOverlays: any;
    isComparisonModeActivated: boolean
};

enum ReportViewType {
    NONE = 0,
    TABLE = 1,
    BAR_CHART = 2,
    PIE_CHART = 3,
}

enum ChartViewType {
    NONE = 0,
    AGGREGATE = 1,
    COUNT = 2,
    AVERAGE = 3,
}

enum ColumnNumber {
    FIRST_COLUMN = 1,
    SECOND_COLUMN = 2,
    THIRD_COLUMN = 3,
}
@Component({
    selector: "map-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
    @ViewChild("workspaceItemDialog", { static: true })
    workspaceIemDialog: WorkspaceItemDialogComponent;
    @ViewChild("pdfTable", { static: false }) pdfTable: ElementRef;
    MaptycsApplication = MaptycsApplication;
    filterFieldSearchFilter: (field: DatasetField) => boolean;
    dashboardWorkspaceItems: WorkspaceItem[] = [];

    dataset: Dataset;
    activeDataset: Dataset;
    thematicLevels: Dataset[] = [];
    linkedDatasets: Dataset[];
    datasetFields: DatasetField[];
    _analytics: WorkspaceItem[];
    _formulas: WorkspaceItem[];
    private readonly subscriptions: Subscription = new Subscription();
    private floatingFieldsDataSubscription: Subscription =
        new Subscription();
    private currentLoadRequestId: number = 0;
    tableColumnsExcludedOverlayGroups: number[];

    aggregateModel = new Aggregate(
        this.datapointsPageStateService,
        this.aggregateService
    );

    rankingModel = new Ranking(
        this.datapointsPageStateService,
        this.datapointService
    );

    // ⭐ NEW: Cache for pre-processed climate data (performance optimization for multiple ranking reports)
    private preparedClimateDataCache: TreeStructure[] = null;

    customScorings: any[] = [];

    filterTreeStrcuture = new TreeStructureUtils();
    aggregateDatas: any = [];
    countDataArray: any = [];
    analyticData: any = [];
    cloneAnalyticData: any = [];
    analyticsColumnOne: any = [];
    analyticsColumnTwo: any = [];
    analyticsColumnThree: any = [];

    columnNumbersArray = [
        ColumnNumber.FIRST_COLUMN,
        ColumnNumber.SECOND_COLUMN,
        ColumnNumber.THIRD_COLUMN,
    ];

    isAnalyticsPrepared = false;

    groups: any[] = [];
    _compareGroups = [];
    _withGroups = [];
    groupsStrcuture: TreeStructure[];
    _compareGroupsStrcuture: any[] = [];
    _withGroupsStrcuture: any[] = [];

    dropdownItems: TreeStructure[] = [];
    selectedDropdownItems: TreeStructure[] = [];
    selectedThematicLevel: any;
    groupAlias: string = "Groups";
    groupAliasForm: UntypedFormGroup;
    sidebarDataValues: any[] = [];
    sidebarCountDataValues: any[] = [];
    thematicMapGrouping: string = Grouping.SUM;
    thematicMapMetric: DatasetField;
    isSidebarDataLoaded: boolean = false;
    selectedGroupIds = [];

    countModel = new Count(
        this.datapointsPageStateService,
        this.aggregateService,
        this.overlayService
    );

    isSuperAdmin: boolean;
    hasAccess: boolean;

    columnNumbers = ColumnNumber;

    indicatorsData: IndicatorsData;

    readonly COUNT_COLUMN_ID = "count";
    readonly AGGREGATE_COLUMN_ID = "aggregate";
    readonly PERCENTAGE_COLUMN_ID = "percentage";
    readonly TOTAL_COLUMN_ID = "total";
    readonly BLANK_COLUMN_ID = "blank";
    readonly AVERAGE_COLUMN_ID = "average";
    readonly REPORT_TYPE_MASTER = ReportType;

    readonly RANKING_COLUMN_ID = "ranking";

    tessadataFields: {
        nriFields: DatasetField[];
        externalFields: DatasetField[];
    };
    downloadModel = new DownloadReport(this.downloadService, this.notifService, this.dialog);
    MIN_DIMENSIONS_PX: number = 320;
    accountId: number;
    overlaysGroupAsTree: any[] = [];
    parentOverlay: any;
    filterAccountOverlays: any = [];
    linkedOverlays: any[] = [];
    ulClassName: 'dashboardLocation';
    isComparisonModeActivated: boolean = false;
    childrenGroups: Group[];

    get AnayticsConstants() {
        return AnayticsConstants;
    }

    get AnalyticsUtils(){
        return AnalyticsUtils
    }

    get RandomUtils(){
        return RandomUtils
    }

    // Counts comparison table headers
    readonly PRIMARY_GROUP_PERCENTAGE_COLUMN_ID = "primaryGroupPercentage";
    readonly SECONDARY_GROUP_PERCENTAGE_COLUMN_ID = "secondaryGroupPercentage";
    readonly PRIMARY_GROUP_COUNT_COLUMN_ID = "primaryGroupCount";
    readonly SECONDARY_GROUP_COUNT_COLUMN_ID = "secondaryGroupCount";
    readonly COMPARE_AMOUNT_COLUMN_ID = "compareAmount";
    readonly COMPARE_COLUMN_ID = "comparePercentage";

    // Aggregate comparison table headers
    readonly PRIMARY_AGGREGATE_COLUMN_ID = "primaryGroupAggregate";
    readonly SECONDARY_AGGREGATE_COLUMN_ID = "secondaryGroupAggregate";
    // readonly PRIMARY_GROUP_PERCENTAGE_COLUMN_ID = "primaryGroupPercentage";
    // readonly SECONDARY_GROUP_PERCENTAGE_COLUMN_ID = "secondaryGroupPercentage";
    // readonly PRIMARY_GROUP_COUNT_COLUMN_ID = "primaryGroupCount";
    // readonly SECONDARY_GROUP_COUNT_COLUMN_ID = "secondaryGroupCount";
    readonly PRIMARY_GROUP_AVERAGE_COLUMN_ID = "primaryGroupAverage";
    readonly SECONDARY_GROUP_AVERAGE_COLUMN_ID = "secondaryGroupAverage";
    // readonly COMPARE_COLUMN_ID = "comparePercentage";

    isAnalyticsPanelOpen: boolean;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly datasetService: DatasetService,
        private readonly overlayService: OverlaysService,
        private readonly groupService: GroupService,
        private readonly datapointsPageStateService: DatapointsPageStateService,
        private readonly accountService: AccountService,
        private readonly workspaceItemService: WorkspaceItemService,
        private readonly linkDatasetService: LinkDatasetService,
        private readonly aggregateService: DatapointsAggregateService,
        private readonly changeDetector: ChangeDetectorRef,
        private formBuilder: UntypedFormBuilder,
        private readonly datapointAggregateService: DatapointsAggregateService,
        private readonly datapointService: DatapointsService,
        private readonly userStateService: UserStateService,
        private readonly downloadService: DownloadService,
        private readonly notifService: NotifService,
        public readonly dialog: MatDialog,
        private readonly sidePanelService: SidePanelService,
        private readonly viewContainerRef: ViewContainerRef,
        private readonly customScoringService: CustomScoringService,
        private readonly dashboardService: DashboardService,
    ) {
        this.groupAliasForm = this.formBuilder.group({
            groupAlias: [this.groupAlias, Validators.required],
        });
        this.isSuperAdmin = this.userStateService.isSuperadmin;
    }

    ngOnInit() {
        let datasetId = this.route.snapshot.paramMap.get("datasetId");
        let accountId = +this.route.snapshot.paramMap.get("accountId");
        this.accountId = +this.route.snapshot.paramMap.get("accountId");

        // Fetch custom scorings for scope filtering (INTERNAL and FORMULA only)
        this.subscriptions.add(
            forkJoin([
                this.customScoringService.getCustomScoringsForAccount(accountId, CustomScoringScope.INTERNAL),
                this.customScoringService.getCustomScoringsForAccount(accountId, CustomScoringScope.FORMULA)
            ]).subscribe(([internalScorings, formulaScorings]) => {
                this.customScorings = [...(internalScorings || []), ...(formulaScorings || [])];

                // Now load account and dataset after custom scorings are loaded
                this.accountService.findAccount(accountId).subscribe((account) => {
                    this.datapointsPageStateService.activeAccount = account;
                    this.activeDataset = account.datasets.filter(
                        (dataset) => dataset.id === datasetId
                    )[0];
                    this.findDataset(datasetId);

                    // Load dashboard indicators after account is set
                    this.dashboardService.getDashboardIndicators(this.datapointsPageStateService.activeAccount.id).subscribe((response) => {
                        this.indicatorsData = response;
                    });
                });
            })
        );
    }

    get ReportDisplayType() {
        return ReportDisplayType;
    }

    get ReportType() {
        return ReportType;
    }

    get ChartDisplayType() {
        return ChartDisplayType;
    }

    public get groupsIds() {
        const groupIds = [];
        this.groups.forEach((rootGroupNode) => {
            this.recursiveOperation(rootGroupNode, (groupNode) => {
                groupIds.push(groupNode.value.id);
            });
        });
        return groupIds;
    }

    get DatasetFieldSpecificType() {
        return DatasetFieldSpecificType;
    }

    get DatasetFieldType() {
        return DatasetFieldType;
    }

    get datasetScope() {
        return DatasetFieldScope;
    }

    setDisplayType(counter, reportSubType: string, columnNumber: number) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        selectedColumnData[counter].reportSubType = reportSubType;

        if(reportSubType === ReportDisplayType.BAR_CHART || reportSubType === ReportDisplayType.PIE_CHART){
            if(selectedColumnData[counter].reportType === this.REPORT_TYPE_MASTER.AGGREGATE || selectedColumnData[counter].reportType === this.REPORT_TYPE_MASTER.AVERAGE){
                this.aggregateModel.populateChartData(selectedColumnData[counter], this.isComparisonModeActivated);
            } else{
                this.countModel.populateChartData(selectedColumnData[counter], this.isComparisonModeActivated);
            }

            if(reportSubType === ReportDisplayType.BAR_CHART){
                selectedColumnData[counter].chart.chartOptions.scales = {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                callback: (value, index, values) => {
                                    return StringUtils.numberWithCommas(value);
                                },
                            },
                        },
                    ],
                }
                selectedColumnData[counter].chart.chartOptions.scales.yAxes[0].ticks.beginAtZero = true;
            } else {
                selectedColumnData[counter].chart.chartOptions.scales = null
            }
        } else {
            selectedColumnData[counter].chart.chartOptions.scales = null
        }
        this.saveState(counter, columnNumber);
    }

    findDataset(datasetID: string) {
        this.datasetService.getDataset(datasetID).subscribe((response) => {
            this.dataset = response;
            this.hasAccess = this.userStateService.isSuperadmin || this.userStateService.isAccountAdmin(this.dataset.accountID);
            this.fetchDashboardWorkspaceItems();
            this.datapointsPageStateService.setActiveDataset(
                this.activeDataset
            );
            this.datapointsPageStateService.setFilterAccountDatasets([
                this.activeDataset,
            ]);
            this.subscriptions.add(
                forkJoin(
                    this.overlayService.getAllAccountOverlays(
                        this.dataset.accountID
                    ),
                    this.groupService.getGroupsAsTree(
                        this.dataset.id,
                        this.dataset.accountID
                    ),
                    this.workspaceItemService.getAllWorkspaceItemsForUser(
                        this.dataset.id,
                        WorkspaceItemType.DASHBOARD
                    ),
                    this.workspaceItemService.getAllWorkspaceItemsForUser(
                        this.dataset.id,
                        WorkspaceItemType.FORMULA
                    ),
                    this.linkDatasetService.getLinkedAccountApplications(
                        this.dataset.id
                    ),
                    this.overlayService.getOverlayGroupsByTag(
                        OverlaysConstants.HIDE_GROUP_FROM_TABLE_COLUMNS_TAG
                    ),
                    this.overlayService.getOverlayGroupsAsTree(this.dataset.accountID),
                    this.linkDatasetService.getLinkedOverlays(this.dataset.id),
                    this.groupService.getGroups(
                        this.dataset.id,
                        this.dataset.accountID
                    ),
                ).subscribe(
                    ([
                        overlays,
                        groups,
                        analytics,
                        formulas,
                        linkedDatasets,
                        overlayGroups,
                        overlaysGroupAsTree,
                        linkedOverlays,
                        strcutureGroups
                    ]) => {
                        this.linkedOverlays = linkedOverlays;
                        this._analytics = analytics;
                        this._formulas = formulas;
                        this.tableColumnsExcludedOverlayGroups =
                            overlayGroups.map((group) => group.id);
                        this.groups = groups;
                        this.groupsStrcuture =  AnalyticsUtils.transformTreeStructure(JSON.parse(JSON.stringify(strcutureGroups)));
                        this._compareGroupsStrcuture = ObjectUtils.clone(this.groupsStrcuture);
                        this._withGroupsStrcuture = ObjectUtils.clone(this.groupsStrcuture);
                        this.linkedDatasets = linkedDatasets;
                        this.prepareThematicLevels(overlays);
                        this.overlaysGroupAsTree = overlaysGroupAsTree;
                        this.childrenGroups = this.extractChildrenOnly(this.groups);
                        this._compareGroups = ObjectUtils.clone(this.childrenGroups);
                        this._withGroups = ObjectUtils.clone(this.childrenGroups);
                        this.prepareOverlays(overlays);
                        const isDefaultGroupFunctionalityActive = this.isDefaultGroupFunctionalityActive(this.groups);
                        this.dropdownItems = this.convertToDropdownItems(
                            this.groups,
                            isDefaultGroupFunctionalityActive
                        );
                        this.selectedDropdownItems = this.dropdownItems;
                        this.selectedGroupIds = this.findSelectedGroupIds(this.selectedDropdownItems);

                        // ⭐ FIX: Fetch climate overlays first, then load reports
                        this.linkDatasetService
                                .linkedGroupOverlays(
                                    this.dataset.id
                                ).subscribe((res) => {
                                    this.filterAccountOverlays = this.sortFilterAccountOverlays(res);
                                    this.filterAccountOverlays = this.prepareFilterAcccountOverlays(this.filterAccountOverlays);

                                    // ⭐ NOW load analytics and reports AFTER filterAccountOverlays is set
                        this.prepareAnalytics();
                        this.sidebarDataValues = [];
                        this.sidebarCountDataValues = [];
                        this.loadReportData(null, true);
                        });
                        setTimeout(() => {
                            const sortedDashboards = this.dashboardWorkspaceItems.slice().sort((a, b) => a.sequence - b.sequence);
                            const columnsPerRow = 3;
                            for (let i = 0; i < sortedDashboards.length; i++) {
                                const rowNumber = Math.floor(i / columnsPerRow);
                                const columnNumber = (i % columnsPerRow) + 1;
                                if (sortedDashboards[i].reportSubType === ReportDisplayType.BAR_CHART) {
                                    this.setDisplayType(rowNumber, ReportDisplayType.BAR_CHART, columnNumber);
                                }
                            }
                        }, 2000);
                    }
                )
            );
        });
    }

    findSelectedGroupIds(items: TreeStructure[]): number[] {
        let selectedIds = []
        if (items) {
            items.forEach((item) => {
                if (item.children) {
                    selectedIds = selectedIds.concat(this.findSelectedGroupIds(item.children));
                }
                if (item.selected) {
                    selectedIds.push(item.id)
                }
            })
        }
        return selectedIds;
    }

    getAnalyticsFromServer() {
        forkJoin([
            this.workspaceItemService.getAllWorkspaceItemsForUser(
                this.dataset.id,
                this.getActiveDasboardType()
            ),
            this.workspaceItemService.getAllWorkspaceItemsForUser(
                this.dataset.id,
                WorkspaceItemType.FORMULA
            ),
        ]).subscribe(([analytics, formulas]) => {
            this._analytics = analytics;
            this._formulas = formulas;
            this.prepareAnalytics();
        });
    }

    prepareOverlays(overlays: Dataset[]) {
        this.thematicLevels = [];
        overlays.forEach((overlay) => {
            if (
                overlay.thematicMapSettings &&
                overlay.thematicMapSettings.isThematicMapDataset
            ) {
                let parentId = overlay.thematicMapSettings.parentDatasetId;
                this.thematicLevels.push(overlay);
            }
        });
        this.sortThematicLevels();
    }

    sortThematicLevels(): void {
        if (this.thematicLevels && this.thematicLevels.length) {
            this.thematicLevels = [...this.thematicLevels].sort((a, b) =>
                a.name.localeCompare(b.name)
            );
            this.defaultSelectThematicLevel();
        }
    }

    defaultSelectThematicLevel() {
        if (this.thematicLevels && this.thematicLevels.length) {
            this.selectedThematicLevel = this.thematicLevels[0];
        }
    }

    onLevelChange(levelID: string): void {
        this.selectedThematicLevel = this.thematicLevels.find(
            (level) => level.id === levelID
        );
        this.sidebarDataValues = [];
        this.sidebarCountDataValues = [];
    }

    loadReportData(dialogIndicators: IndicatorField[] = null, onInit: Boolean = false) {
        // Cancel any pending subscriptions to prevent duplicate values
        this.floatingFieldsDataSubscription.unsubscribe();
        this.floatingFieldsDataSubscription = new Subscription();
        this.sidebarDataValues = [];

        // Increment request ID to invalidate any pending async results from previous calls
        const requestId = ++this.currentLoadRequestId;

        const dashboardSubscription = this.dashboardService.getDashboardIndicators(this.datapointsPageStateService.activeAccount.id).subscribe((response) => {
            // Check if this response is still valid (no newer request has been made)
            if (requestId !== this.currentLoadRequestId) {
                return;
            }
            this.indicatorsData = response;
            if (dialogIndicators) {
                this.indicatorsData.fields = dialogIndicators;
            }

            // Clear sidebar values here to ensure any pending async results from previous calls don't interfere
            this.sidebarDataValues = [];
            this.isSidebarDataLoaded = false;
            const datasetId = this.route.snapshot.paramMap.get("datasetId");
            let indicators = [];
            let indicatorsIds = [];
            let formulaIndicators = [];  // Declare formulaIndicators here

            if (this.indicatorsData?.fields?.length) {
                // Convert IDs to strings for consistent comparison (DatasetField.id is string, IndicatorField.id is number)
                const availableFieldIds = new Set(this.datasetFields?.map(f => String(f.id)) || []);
                const formulaIds = new Set(this._formulas?.map(f => String(f.id)) || []);
                
                indicators = this.indicatorsData.fields.filter(item => item.isIndicators === true);

                const locationIndicators = indicators.filter(item => {
                    const idStr = String(item.id);
                    if (item.type === 'FORMULA') return false;
                    if (item.type === 'LOCATION') return availableFieldIds.has(idStr);
                    // No type set - check if it's a formula, otherwise treat as location
                    return !formulaIds.has(idStr) && availableFieldIds.has(idStr);
                });

                formulaIndicators = indicators.filter(item => {
                    const idStr = String(item.id);
                    if (item.type === 'FORMULA') return formulaIds.has(idStr);
                    if (item.type === 'LOCATION') return false;
                    // No type set - include if it's a known formula
                    return formulaIds.has(idStr);
                });

                indicatorsIds = locationIndicators
                    .map(item => item.id)
                    .filter(id => id != null);
            }

            // Declare the filter and projection objects before using them
            const filter = {
                datasetID: datasetId,
                groups: onInit ? this.selectedGroupIds : this.getSelectedGroupIds(),
                fields: [],
                links: [],
            };

            const projection = {
                datasetID: datasetId,
                fields: indicatorsIds,
                links: [
                    {
                        datasetID: this.selectedThematicLevel && this.selectedThematicLevel.id,
                        fields: [
                            this.selectedThematicLevel &&
                                this.selectedThematicLevel.thematicMapSettings.mainThematicFieldId,
                        ],
                    },
                ],
            };
            projection.fields = projection.fields.filter(field => field !== null && field !== undefined);

            // Process formula indicators separately if there are any
            if (formulaIndicators.length > 0) {
                this.processFormulaIndicators(formulaIndicators, filter, projection, requestId);
            }
            // else {
            //     // Fill the projection.fields back with the location indicator IDs
            //     projection.fields = indicatorsIds;  // Restore location indicator fields
            // }

            // Fetch data for datapoints count
            this.datapointAggregateService
                .getDatapointsCount(datasetId, filter, projection)
                .subscribe((countResult) => {
                    if (countResult && countResult.count) {
                        this.sidebarCountDataValues = [];
                        this.sidebarCountDataValues.push({
                            id: 0,
                            dataLabel: "Count",
                            dataValue: countResult.count,
                            sequence: 0,
                            disabled: true
                        });
                    }
                });

            // Handle other indicators for sidebar
            if (indicators.length) {
                this.thematicMapMetric = indicators[0];
                this.addIndicatorsValuesForSidebar(indicators, filter, projection);
            }
        });

        // Add dashboard subscription to be cancelled when loadReportData is called again
        this.floatingFieldsDataSubscription.add(dashboardSubscription);
    }



    addIndicatorsValuesForSidebar(
        indicators: IndicatorField[],
        filter,
        projection
    ) {
        let loadedCount = 0;
        this.sidebarDataValues =[];
        const nonFormulaIndicators = indicators.filter(field => field.type !== 'FORMULA');
        const totalIndicatorsToLoad = nonFormulaIndicators.length;

        if (nonFormulaIndicators && nonFormulaIndicators.length) {
            nonFormulaIndicators.forEach((field) => {
                let groups: AggregateGroupRequest[] = [];
                groups.push({
                    datasetID:
                        this.selectedThematicLevel &&
                        this.selectedThematicLevel.id,
                    fieldID:
                        this.selectedThematicLevel.thematicMapSettings
                            .mainThematicFieldId,
                });

                let formulaId = `${this.dataset.id}.${field.id}`;
                let reportRequest: ReportRequest = {
                    datasetID: this.dataset.id,
                    aggregateFieldCodes: [
                        {
                            aggregateFieldCode: `VAR_${formulaId}`,
                            id: formulaId,
                        },
                    ],
                    groups: groups,
                    aggregateFieldType: DatapointAggregateFieldType.FIELD,
                };

                const subscription = this.datapointAggregateService
                    .getDatapointsReport(
                        this.dataset.id,
                        filter,
                        reportRequest,
                        projection
                    )
                    .subscribe((result) => {
                        let totalValue = 0;
                        result.groupResults.forEach((groupResult) => {
                            if (
                                field.indicatorsOption ===
                                DatasetFieldFloatingOption.SUM
                            ) {
                                totalValue += groupResult.values[0].result;
                            } else {
                                totalValue +=
                                    groupResult.values[0].result /
                                    groupResult.values[0].count;
                            }
                        });
                        totalValue = Math.round(totalValue * 100) / 100;
                        this.sidebarDataValues.push({
                            id: field.id,
                            dataLabel: decodeHtmlText(field.name),
                            dataValue: totalValue,
                            sequence: field.sequence,
                            disabled: !this.hasAccess
                        });

                        loadedCount++;
                        if (loadedCount === totalIndicatorsToLoad) {
                            this.sidebarDataValues.sort((a, b) => a.sequence - b.sequence);
                            this.isSidebarDataLoaded = true;
                        }
                    });

                this.floatingFieldsDataSubscription.add(subscription); // Add the subscription to the floatingFieldsDataSubscription object
            });
        } else {
            this.isSidebarDataLoaded = true;
        }
    }
    processFormulaIndicators(formulaIndicators: IndicatorField[], filter: any, projection: any, requestId: number) {
        const formulaFetchSubscription = this.workspaceItemService.getAllWorkspaceItemsForUser(
            this.dataset.id,
            WorkspaceItemType.FORMULA
        ).subscribe(formulas => {
            const indicatorByFormulaId = this.matchIndicatorsToFormulas(formulaIndicators, formulas);
            if (indicatorByFormulaId.size === 0) {
                return;
            }

            const sumFormulaIds: number[] = [];
            indicatorByFormulaId.forEach((indicator, formulaId) => {
                if (indicator.indicatorsOption === DatasetFieldFloatingOption.AVG) {
                    const matchingFormula = formulas.find(f => f.id === formulaId);
                    if (matchingFormula) {
                        this.loadAverageFormulaIndicator(matchingFormula, indicator, filter, projection, requestId);
                    }
                } else {
                    sumFormulaIds.push(formulaId);
                }
            });

            if (sumFormulaIds.length === 0) {
                return;
            }

            const subscription = this.datapointAggregateService
                .getDashboardFormulaIndicators(this.dataset.id, sumFormulaIds, filter)
                .subscribe(results => {
                    if (requestId !== this.currentLoadRequestId) {
                        return;
                    }
                    results.forEach(result => {
                        const indicator = indicatorByFormulaId.get(Number(result.id));
                        if (!indicator) {
                            return;
                        }
                        this.sidebarDataValues.push({
                            id: indicator.id,
                            dataLabel: decodeHtmlText(indicator.name),
                            dataValue: this.normalizeFormulaValue(result.averageValue),
                            sequence: indicator.sequence,
                            disabled: !this.hasAccess
                        });
                    });
                });
            this.floatingFieldsDataSubscription.add(subscription);
        });
        this.floatingFieldsDataSubscription.add(formulaFetchSubscription);
    }

    private loadAverageFormulaIndicator(matchingFormula: WorkspaceItem, indicator: IndicatorField, filter: any, projection: any, requestId: number) {
        const formulaData = JSON.parse(JSON.stringify(matchingFormula.data));

        const groups: AggregateGroupRequest[] = [{
            datasetID: this.dataset.id,
            fieldID: this.selectedThematicLevel.thematicMapSettings.mainThematicFieldId,
        }];

        const reportRequest: ReportRequest = {
            datasetID: this.dataset.id,
            aggregateFieldCodes: [
                {
                    aggregateFieldCode: `FORMULA_${matchingFormula.id}_${Date.now()}`,
                    id: `${matchingFormula.id}`
                }
            ],
            groups: groups,
            aggregateFieldType: DatapointAggregateFieldType.FORMULA,
            aggregateFieldFormulaJson: formulaData
        };

        const formulaProjection = {
            ...projection,
            fields: [],
            links: []
        };

        const subscription = this.datapointAggregateService
            .getDatapointsReport(this.dataset.id, filter, reportRequest, formulaProjection)
            .subscribe(result => {
                if (requestId !== this.currentLoadRequestId) {
                    return;
                }
                let totalValue = 0;
                result.groupResults.forEach(groupResult => {
                    totalValue += groupResult.values[0].result / groupResult.values[0].count;
                });
                this.sidebarDataValues.push({
                    id: indicator.id,
                    dataLabel: decodeHtmlText(indicator.name),
                    dataValue: this.normalizeFormulaValue(totalValue),
                    sequence: indicator.sequence,
                    disabled: !this.hasAccess
                });
            });
        this.floatingFieldsDataSubscription.add(subscription);
    }

    private matchIndicatorsToFormulas(indicators: IndicatorField[], formulas: WorkspaceItem[]): Map<number, IndicatorField> {
        const normalize = (name?: string) => name?.trim().toLowerCase();
        const claimed = new Set<number>();
        const result = new Map<number, IndicatorField>();

        const findMatch = (indicator: IndicatorField): WorkspaceItem | undefined => {
            const indicatorName = normalize(indicator.name);
            return formulas.find(f => !claimed.has(f.id) && f.id === indicator.id && normalize(f.name) === indicatorName)
                ?? formulas.find(f => !claimed.has(f.id) && f.id === indicator.id)
                ?? formulas.find(f => !claimed.has(f.id) && normalize(f.name) === indicatorName);
        };

        indicators.forEach(indicator => {
            const match = findMatch(indicator);
            if (match) {
                claimed.add(match.id);
                result.set(match.id, { ...indicator, id: match.id, name: match.name });
            }
        });
        return result;
    }

    private normalizeFormulaValue(raw: number | null | undefined): number {
        if (raw === null || raw === undefined || isNaN(raw) || !isFinite(raw)) {
            return 0;
        }
        return Math.round(raw * 100) / 100;
    }


    convertToDropdownItems(
        data: any[],
        isDefaultGroupFunctionalityActive: boolean,
        parent?: TreeStructure
    ): TreeStructure[] {
        const accountId = +this.route.snapshot.paramMap.get("accountId");
        const key = getGroupsLocalStorageKey(accountId);
        let storedGroupIds: number[] = [];
        const saved = localStorage.getItem(key);
        if (saved) {
          storedGroupIds = JSON.parse(saved);
        }
        return data.map((item) => {
            const isGroupSelectedByDefault =
                parent?.selected || item.value.isDefault === true;
            const groupId = item.value.id;
            const isSelected = (storedGroupIds.length === 0) || storedGroupIds.includes(groupId);
            const selected = this.findGroupSelected(storedGroupIds,isDefaultGroupFunctionalityActive,isGroupSelectedByDefault,isSelected);

            const dropdownItem: TreeStructure = {
                id: groupId,
                params: {
                    accountID: item.value.accountID,
                    datasetID: item.value.datasetID,
                    type: item.value.type,
                    parent: parent,
                },
                name: item.value.name,
                selected: selected,
                expanded: false,
                isDefault: item.value.isDefault,
            };

            if (item.children && item.children.length > 0) {
                dropdownItem.children = this.convertToDropdownItems(
                    item.children,
                    isDefaultGroupFunctionalityActive,
                    dropdownItem
                );
            }

            return dropdownItem;
        });
    }

    findGroupSelected(storedGroupIds: number[], isDefaultGroupFunctionalityActive: boolean, isGroupSelectedByDefault: boolean, isSelected: boolean) {
        if(storedGroupIds.length === 0){
            if(isDefaultGroupFunctionalityActive){
                return isGroupSelectedByDefault
            }else{
                return false;
            }
        }else{
            return isSelected;
        }
    }

    isDefaultGroupFunctionalityActive(groups: GroupTreeNode[]): boolean {
        for (const group of groups) {
            if (group.value.isDefault === true) {
                return true;
            }
            if (group.children?.length) {
                if (this.isDefaultGroupFunctionalityActive(group.children)) {
                    return true;
                }
            }
        }
        return false;
    }

    recursiveOperation(
        groupNode: GroupTreeNode,
        operation: (node: GroupTreeNode) => void
    ) {
        operation(groupNode);
        groupNode.children.forEach((child) =>
            this.recursiveOperation(child, operation)
        );
        // this.changeEvent();
    }

    sortFields(fields: DatasetField[]) {
        fields.sort((item1, item2) => {
            if (item1 && item1.name && item2 && item2.name) {
                return item1.name
                    .trim()
                    .toLowerCase()
                    .localeCompare(item2.name.trim().toLowerCase());
            }
        });
        return fields;
    }

    generateReport(report: any) {
        let abc = this.aggregateModel.generateReport(
            report,
            this.dataset,
            this.selectedGroupIds,
            AnalyticsUtils.getSelectedGroups(report).map((group) => {
                return group.id;
            }) || [],
           this.isComparisonModeActivated,
        );
    }

    onAggregateFieldSelected(
        fieldSelected: boolean,
        field: DatasetField,
        counter: number,
        columnNumber: number
    ) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        let aggregateData = selectedColumnData[counter];
        if (fieldSelected) {
            aggregateData.selectedAggregateField = field;
            aggregateData.aggregateDatasetFields.forEach((f) => {
                f.selected = f.id === field.id;
            });
            aggregateData.selectedFormula = undefined;
            aggregateData.formulas.forEach(
                (formula) => (formula.selected = false)
            );
        } else {
            aggregateData.selectedAggregateField = undefined;
        }
        this.changeDetector.detectChanges();
    }

    onAggregateFieldModelChangeEvent(node, counter: number, columnNumber: number) {
        if (!isUndefined(node.params)) {
            const field = node.params.field;
            if (node.params.callType == 'dataset') {
                this.onAggregateFieldSelected(node.selected, node.params?.field, counter, columnNumber);
            } else if (node.params.callType == 'formula') {
                this.onFormulaSelected(node.selected, node.params?.field, counter, columnNumber);
            }
        }
    }

    onFormulaSelected(
        fieldSelected: boolean,
        selectedFormula: WorkspaceItem,
        counter: number,
        columnNumber: number
    ) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        let aggregateData = selectedColumnData[counter];
        if (fieldSelected) {
            aggregateData.formulas.forEach((formula) => {
                formula.selected = formula.id === selectedFormula.id;
            });
            aggregateData.selectedFormula = selectedFormula;
            aggregateData.selectedAggregateField = undefined;
            this.datasetFields.forEach((f) => (f.selected = false));
        } else {
            aggregateData.selectedFormula = undefined;
            selectedFormula.selected = false;
            aggregateData.selectedAggregateField = undefined;
        }
        this.changeDetector.detectChanges();
    }

    onFieldsMenuClick(
        fieldSelected: boolean,
        field: DatasetField,
        counter: number,
        columnNumber: number,
        overlay?: Dataset
    ) {
        const validDataset = overlay || this.activeDataset;

        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        let aggregateData = selectedColumnData[counter];

        let datasetFields =
            aggregateData.selectedBreakdownFieldsByDataset.get(
                validDataset.id
            ) || [];

        if (fieldSelected) {
            datasetFields.push(field);
            field.selected = true;
            aggregateData.selectedBreakdownFieldsCount++;
        } else {
            datasetFields = datasetFields.filter((f) => f.id !== field.id);
            field.selected = false;
            aggregateData.selectedBreakdownFieldsCount--;
        }

        if (datasetFields.length === 0) {
            aggregateData.selectedBreakdownFieldsByDataset.delete(
                validDataset.id
            );
        } else {
            aggregateData.selectedBreakdownFieldsByDataset.set(
                validDataset.id,
                datasetFields
            );
        }
    }

    onChartDisplayTypeChanged(report: any, counter: number, columnNumber: number) {
        this.setDisplayType(counter, report.reportSubType, columnNumber);
        report.chartDownloadRequest = !this.isComparisonModeActivated ? this.aggregateModel.getChartReportDownloadRequest(report, this.activeDataset) : this.aggregateModel.getChartReportDownloadRequestForComparison(report);
        this.saveState(counter, columnNumber);
    }

    prepareCommanMenuOptions() {
        let tessadataFields: {
            nriFields: DatasetField[];
            externalFields: DatasetField[];
            customScoreFields: DatasetField[];
          //  tensorflightFields: DatasetField[];
            e2valueFields: DatasetField[];
            munichreFields: DatasetField[];
            consolidatedRiskScoreFields: DatasetField[];
        };
        let tessadataGroupedFields: any[];
        tessadataFields = JSON.parse(
            JSON.stringify(
                this.datapointsPageStateService.getActiveTessadataFields()
            )
        );
        tessadataFields.externalFields.forEach(
            (field) => (field.selected = false)
        );
        tessadataFields.nriFields = this.sortFields(tessadataFields.nriFields);
        
        // Filter and sort custom score fields (INTERNAL and FORMULA scope only)
        if (tessadataFields.customScoreFields) {
            tessadataFields.customScoreFields.forEach(
                (field) => {
                    field.selected = false;
                    // Set tag for grouping
                    if (!field.tags || field.tags.length === 0) {
                        field.tags = ['Custom Score'];
                    }
                }
            );
            // Filter out GLOBAL and EXTERNAL scope custom scores
            tessadataFields.customScoreFields = tessadataFields.customScoreFields.filter(field => {
                const customScoreId = parseInt(field.id.replace('custom_score_', ''), 10);
                const isValidCustomScore = this.customScorings.some(cs => cs._id === customScoreId);
                return isValidCustomScore;
            });
            tessadataFields.customScoreFields = this.sortFields(tessadataFields.customScoreFields);
        }
        if (
            tessadataFields.externalFields &&
            tessadataFields.externalFields.length > 0
        ) {
            let externalDataset = this.sortFields(
                tessadataFields.externalFields
            );
            tessadataGroupedFields = externalDataset.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            for (const key in tessadataGroupedFields) {
                if (
                    Object.prototype.hasOwnProperty.call(
                        tessadataGroupedFields,
                        key
                    )
                ) {
                    tessadataGroupedFields[key] = this.sortFields(
                        tessadataGroupedFields[key]
                    );
                }
            }
        }
     //   tessadataFields.tensorflightFields.forEach(
            (field) => (field.selected = false)
      //  );
      //  if (
      //      tessadataFields.tensorflightFields &&
      //      tessadataFields.tensorflightFields.length > 0
      //  )
       {
      //      let tensorflightDatasets = this.sortFields(
      //       tessadataFields.tensorflightFields
      //     );
      /*      let tensorflightGroupFields = tensorflightDatasets.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            ); */
         //   tessadataGroupedFields = !isUndefined(tessadataGroupedFields) && Object.keys(tessadataGroupedFields).length ? {...tessadataGroupedFields, ...tensorflightGroupFields} : tensorflightGroupFields;
        }

        tessadataFields.e2valueFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            tessadataFields.e2valueFields &&
            tessadataFields.e2valueFields.length > 0
        ) {
            let e2valueDatasets = this.sortFields(
                tessadataFields.e2valueFields
            );
            let e2valueGroupFields = e2valueDatasets.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [...(groups[item.tags[0]] || []), item],
                }),
                []
            );
            tessadataGroupedFields = !isUndefined(tessadataGroupedFields) && Object.keys(tessadataGroupedFields).length ? {...tessadataGroupedFields, ...e2valueGroupFields} : e2valueGroupFields;
        }

        tessadataFields.munichreFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            tessadataFields.munichreFields &&
            tessadataFields.munichreFields.length > 0
        ) {
            let munichreDatasets = this.sortFields(
                tessadataFields.munichreFields
            );
            let munichreGroupFields = munichreDatasets.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.tags[0]]: [
                        ...(groups[item.tags[0]] || [])
                            .map(group => group[item.tags[1]] ? {
                                ...group, [item.tags[1]]:
                                    [...group[item.tags[1]], item]
                            } : group
                            ),
                        ...(groups[item.tags[0]]?.some(group => group[item.tags[1]]) ? [] : [{ [item.tags[1]]: [item] }])
                    ]
                }),
                []
            );
            tessadataGroupedFields = !isUndefined(tessadataGroupedFields) && Object.keys(tessadataGroupedFields).length ? {...tessadataGroupedFields, ...munichreGroupFields} : munichreGroupFields;
        }

        tessadataFields.consolidatedRiskScoreFields.forEach(
            (field) => (field.selected = false)
        );
        if (
            tessadataFields.consolidatedRiskScoreFields &&
            tessadataFields.consolidatedRiskScoreFields.length > 0
        ) {
            tessadataGroupedFields = DatasetUtils.mergeTagGroupedFields(
                this.sortFields(tessadataFields.consolidatedRiskScoreFields),
                tessadataGroupedFields
            );
        }

        tessadataFields.nriFields = this.groupByNriFields(
            tessadataFields.nriFields
        );

        // Add custom score fields to grouped fields at the end
        if (tessadataFields.customScoreFields && tessadataFields.customScoreFields.length > 0) {
            tessadataGroupedFields['Custom Score'] = tessadataFields.customScoreFields;
        }

        this.tessadataFields = tessadataFields;
        return {
            tessadataFields: tessadataFields,
            tessadataGroupedFields: tessadataGroupedFields,
        };
    }

    /**
     * Check if a dashboard widget uses any deleted fields
     * Returns true if widget should be hidden, false if it should be displayed
     */
    checkIfWidgetUsesDeletedFields(widgetData: any, availableFieldIds: Set<any>, availableFormulaIds: Set<number>): boolean {
        // Check different widget types for field references
        
        // Check selected fields (for aggregate, count, ranking reports)
        if (widgetData.selectedFields && Array.isArray(widgetData.selectedFields)) {
            for (const field of widgetData.selectedFields) {
                if (field.id && !availableFieldIds.has(field.id)) {
                    return true; // Field is deleted
                }
                // Also check if it's a custom score field that no longer exists
                if (field.id && typeof field.id === 'string' && field.id.startsWith('custom_score_')) {
                    if (!availableFieldIds.has(field.id)) {
                        return true;
                    }
                }
            }
        }
        
        // Check selected aggregate field
        if (widgetData.selectedAggregateField) {
            const fieldId = widgetData.selectedAggregateField.id;
            if (fieldId && !availableFieldIds.has(fieldId)) {
                return true;
            }
            // Check if it's a custom score field
            if (fieldId && typeof fieldId === 'string' && fieldId.startsWith('custom_score_')) {
                if (!availableFieldIds.has(fieldId)) {
                    return true;
                }
            }
        }
        
        // Check selected ranking field
        if (widgetData.selectedRankingField) {
            const fieldId = widgetData.selectedRankingField.id;
            if (fieldId && !availableFieldIds.has(fieldId)) {
                return true;
            }
            // Check if it's a custom score field
            if (fieldId && typeof fieldId === 'string' && fieldId.startsWith('custom_score_')) {
                if (!availableFieldIds.has(fieldId)) {
                    return true;
                }
            }
        }
        
        // Check selected formula
        if (widgetData.selectedFormula) {
            const formulaId = Number(widgetData.selectedFormula.id);
            if (formulaId && !availableFormulaIds.has(formulaId)) {
                return true;
            }
        }
        
        // Check breakdown fields
        if (widgetData.selectedBreakdownFields && Array.isArray(widgetData.selectedBreakdownFields)) {
            for (const field of widgetData.selectedBreakdownFields) {
                if (field.id && !availableFieldIds.has(field.id)) {
                    return true;
                }
            }
        }
        
        // Check selectedBreakdownFieldsByDataset (Map of datasetId -> fields array)
        if (widgetData.selectedBreakdownFieldsByDataset) {
            for (const datasetId in widgetData.selectedBreakdownFieldsByDataset) {
                const fields = widgetData.selectedBreakdownFieldsByDataset[datasetId];
                if (Array.isArray(fields)) {
                    for (const field of fields) {
                        if (field.id && !availableFieldIds.has(field.id)) {
                            return true;
                        }
                        // Check if it's a custom score field
                        if (field.id && typeof field.id === 'string' && field.id.startsWith('custom_score_')) {
                            if (!availableFieldIds.has(field.id)) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
        
        // Check selectedFieldsByDataset (Map of datasetId -> fields array)
        if (widgetData.selectedFieldsByDataset) {
            for (const datasetId in widgetData.selectedFieldsByDataset) {
                const fields = widgetData.selectedFieldsByDataset[datasetId];
                if (Array.isArray(fields)) {
                    for (const field of fields) {
                        if (field.id && !availableFieldIds.has(field.id)) {
                            return true;
                        }
                        // Check if it's a custom score field
                        if (field.id && typeof field.id === 'string' && field.id.startsWith('custom_score_')) {
                            if (!availableFieldIds.has(field.id)) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
        
        // Check aggregateDatasetFields array (may contain custom score fields)
        if (widgetData.aggregateDatasetFields && Array.isArray(widgetData.aggregateDatasetFields)) {
            for (const field of widgetData.aggregateDatasetFields) {
                // Check if field is selected and is a custom score
                if (field.selected && field.id && typeof field.id === 'string' && field.id.startsWith('custom_score_')) {
                    if (!availableFieldIds.has(field.id)) {
                        console.log('  - Deleted custom score in aggregateDatasetFields found:', field.id, field.name);
                        return true;
                    }
                }
            }
        }
        
        // Check datasetFields array (may contain custom score fields)
        if (widgetData.datasetFields && Array.isArray(widgetData.datasetFields)) {
            for (const field of widgetData.datasetFields) {
                // Check if field is selected and is a custom score
                if (field.selected && field.id && typeof field.id === 'string' && field.id.startsWith('custom_score_')) {
                    if (!availableFieldIds.has(field.id)) {
                        console.log('  - Deleted custom score in datasetFields found:', field.id, field.name);
                        return true;
                    }
                }
            }
        }
        
        // All fields exist - widget is valid
        return false;
    }

    prepareAnalytics() {
        let reportElementIndex = 0;
        this.analyticData = [];
        this.analyticsColumnOne = [];
        this.analyticsColumnTwo = [];
        this.analyticsColumnThree = [];
        this.analyticData = [];
        const datasetFields = this.dataset.fields;
        this.datasetFields = this.sortFields(
            JSON.parse(JSON.stringify(datasetFields))
        );
        
        // Build set of available field IDs to validate dashboard widgets
        const availableFieldIds = new Set(this.datasetFields?.map(f => f.id) || []);
        const availableFormulaIds = new Set(this._formulas?.map(f => Number(f.id)) || []);
        
        let menuOptionData = this.prepareCommanMenuOptions();

        this._analytics.forEach((analytic) => {
            const analyticParseData = JSON.parse(analytic.data);
            if (analyticParseData.length) {
                analyticParseData.forEach((data) => {
                    // DASHBOARD WIDGET VALIDATION: Check if widget uses deleted fields
                    // Skip rendering widgets that reference deleted custom score fields
                    const widgetUsesDeletedFields = this.checkIfWidgetUsesDeletedFields(data, availableFieldIds, availableFormulaIds);
                    if (widgetUsesDeletedFields) {
                        return; // Skip this widget
                    }
                    
                    let selectedGroupIds = [];
                    const accountId = +this.route.snapshot.paramMap.get('accountId');
                    const key = getGroupsLocalStorageKey(accountId);
                    let storedGroupIds: number[] = [];
                    const saved = localStorage.getItem(key);
                    if (saved) {
                        storedGroupIds = JSON.parse(saved);
                    }
                    selectedGroupIds = storedGroupIds.length > 0 ? storedGroupIds : this.selectedGroupIds;
                    switch (data.type) {
                        case ReportType.AGGREGATE: {
                            const aggregateData: any =
                                this.aggregateModel.process(
                                    this.dataset,
                                    reportElementIndex,
                                    analytic,
                                    data,
                                    JSON.parse(JSON.stringify(datasetFields)),
                                    JSON.parse(JSON.stringify(this._formulas)),
                                    selectedGroupIds,
                                    ObjectUtils.clone(menuOptionData),
                                    this.overlaysGroupAsTree,
                                    this.linkedOverlays,
                                    ObjectUtils.clone(this.groupsStrcuture),
                                    this.isComparisonModeActivated
                                );
                            if (aggregateData !== undefined) {
                                aggregateData.id = analytic.id;
                                aggregateData.reportType = ReportType.AGGREGATE;
                                this.analyticData.push(aggregateData);
                            }
                            break;
                        }
                        case ReportType.COUNT: {
                            const countData = this.countModel.process(
                                this.dataset,
                                reportElementIndex,
                                analytic,
                                data,
                                selectedGroupIds,
                                ObjectUtils.clone(menuOptionData),
                                this.overlaysGroupAsTree,
                                this.linkedOverlays,
                                ObjectUtils.clone(this.groupsStrcuture),
                                this.isComparisonModeActivated
                            );
                            if (countData) {
                                countData.reportType = ReportType.COUNT;
                                this.analyticData.push(countData);
                            }
                            break;
                        }
                        case ReportType.RANKING: {
                            const rankingData = this.rankingModel.process(
                                this.dataset,
                                reportElementIndex,
                                analytic,
                                data,
                                JSON.parse(JSON.stringify(datasetFields)),
                                JSON.parse(JSON.stringify(this._formulas)),
                                ObjectUtils.clone(menuOptionData),
                                selectedGroupIds,
                                ObjectUtils.clone(this.groupsStrcuture),
                                this.isComparisonModeActivated,
                                this.prepareClimateOverlays(),      // ⭐ Raw overlays for findOverlayById
                                this.getPreparedClimateData()       // ⭐ Pre-processed cached data
                            );
                            if (rankingData !== undefined) {
                                rankingData.id = analytic.id;
                                this.analyticData.push(rankingData);
                            }
                            reportElementIndex++;
                            break;
                        }
                        case ReportType.AVERAGE: {
                            try {
                                const averageData: any =
                                    this.aggregateModel.process(
                                        this.dataset,
                                        reportElementIndex,
                                        analytic,
                                        data,
                                        JSON.parse(JSON.stringify(datasetFields)),
                                        JSON.parse(JSON.stringify(this._formulas)),
                                        selectedGroupIds,
                                        ObjectUtils.clone(menuOptionData),
                                        this.overlaysGroupAsTree,
                                        this.linkedOverlays,
                                        ObjectUtils.clone(this.groupsStrcuture),
                                        this.isComparisonModeActivated
                                    );
                                if (averageData !== undefined) {
                                    averageData.id = analytic.id;
                                    averageData.reportType = ReportType.AVERAGE;
                                    this.analyticData.push(averageData);
                                }
                            } catch (error) {
                                console.error('Error processing AVERAGE report:', error);
                            }
                            break;
                        }
                    }

                    reportElementIndex++;
                });
            }
        });
        if (this.analyticData.length) {
            this.analyticData.sort((a, b) => a.sequence - b.sequence);
            this.cloneAnalyticData = ObjectUtils.clone(this.analyticData);
            this.divideAnalyticsData();
        }
    }

    prepareTesadata(tessadataGroups): TreeStructure[] {
        let sortData = [];
        for (const key in tessadataGroups) {
            if (Object.prototype.hasOwnProperty.call(tessadataGroups, key)) {
                const groups = tessadataGroups[key];
                sortData.push({
                    id: groups.value.id,
                    selected: true,
                    name: groups.value.name,
                    children: this.getGroups(groups.children),
                });
            }
        }
        sortData = sortData.sort((a, b) => (a.name < b.name ? -1 : 1));
        return sortData;
    }

    getGroups(groups): TreeStructure[] {
        let prepareGroups = [];
        groups.forEach((group) => {
            prepareGroups.push({
                id: group.value.id,
                name: group.value.name,
                selected: group.selected,
                params: {
                    field: group,
                    showCheckBox: true,
                    callType: "tesadataGroup",
                },
            });
        });
        return prepareGroups;
    }

    prepareThematicLevels(overlays: Dataset[]) {
        overlays.forEach((overlay) => {
            if (
                overlay.thematicMapSettings &&
                overlay.thematicMapSettings.isThematicMapDataset
            ) {
                let parentId = overlay.thematicMapSettings.parentDatasetId;
                this.thematicLevels.push(overlay);
            }
        });
    }

    getThematicLevelNumber(levelName: string) {
        const levelNameArray: string[] = levelName.split(" ");
        return levelNameArray[levelNameArray.length - 1];
    }

    switchView(viewMode: string): void {
        if (
            viewMode.toUpperCase() === DatapointsViewMode.MAP ||
            viewMode.toUpperCase() === DatapointsViewMode.TABLE
        ) {
            this.router.navigate([
                `private/account/${this.dataset.accountID}/dataset/${this.dataset.id}/datapoints/${viewMode}`,
            ]);
        } else {
            return;
        }
    }

    onSelectedItemsChanged(items: TreeStructure[]): void {
        if (items.length > 0) {
            const accountId = +this.route.snapshot.paramMap.get('accountId');
            const key = getGroupsLocalStorageKey(accountId);
            const groupIds = items.map((item) => item.id);
            localStorage.setItem(key, JSON.stringify(groupIds));
            this.selectedDropdownItems = items;
            this.selectedGroupIds = groupIds;
            this.sidebarDataValues = [];
            this.sidebarCountDataValues = [];
            this.analyticsColumnOne = [];
            this.analyticsColumnTwo = [];
            this.analyticsColumnThree = [];
            this.loadReportData();
            this.getAnalyticsFromServer();
        } else {
            this.notifService.error('Please select at least one group');
        }
    }

    removeAnalyticData(counter: number, columnNumber: number) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        const selectedReport = selectedColumnData[counter];
        selectedColumnData.splice(counter, 1);
        this.analyticData = this.analyticData.filter((report) => selectedReport.id !== report.id)
    }

    isCountFieldSelected(fieldId: string, countReportData: any): boolean {
        if (
            countReportData.selectedFieldsByDataset
                .get(this.activeDataset.id)
                .find((field) => field.id === fieldId)
        ) {
            return true;
        }
        return false;
    }

    generateCountReport(data: any) {
        const params: any = {
            report: data,
            dataset: this.dataset,
            selectedFieldsByDataset: data.selectedFieldsByDataset,
            groupsIds: this.selectedGroupIds,
            isComparisonModeActivated: this.isComparisonModeActivated,
            comparisonGroups: AnalyticsUtils.getSelectedGroups(data).map((group) => {
                return group.id;
            }) || []
        };
        this.countModel.generateReportData(params);
    }

    onCountFieldsMenuClick(
        fieldSelected: boolean,
        field: any,
        reportElementIndex: number,
        columnNumber: number,
        overlay?: Dataset
    ) {
        const validDataset = overlay || this.activeDataset;

        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);

        let selectedFieldsArray = selectedColumnData[
            reportElementIndex
        ].selectedFieldsByDataset.get(validDataset.id);

        if (!selectedFieldsArray) {
            selectedFieldsArray = [],
            selectedColumnData[
                reportElementIndex
            ].selectedFieldsByDataset.set(
                validDataset.id,
                selectedFieldsArray
            );
        }

        if (fieldSelected) {
            selectedFieldsArray.push(field);
            selectedColumnData[reportElementIndex]
                .selectedFieldsByDatasetCount++;
        } else {
            const filteredArray = selectedFieldsArray.filter(
                (obj) => obj.id !== field.id
            );
            selectedColumnData[reportElementIndex]
                .selectedFieldsByDatasetCount--;
            selectedColumnData[reportElementIndex].selectedFieldsByDataset.set(
                validDataset.id,
                filteredArray
            );
        }
    }

    onRankingFieldSelection(
        fieldSelected: boolean,
        field: DatasetField,
        counter: number,
        columnNumber: number,
        overlay?: any  // ⭐ NEW: Overlay reference for climate overlay fields
    ) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        let rankingData = selectedColumnData[counter];

        if (fieldSelected) {
            // Clear formula selection when location is selected
            rankingData.selectedFormula = undefined;
            this.rankingModel.datapointObject.clearAllSelected(rankingData.rankingDataSource.data);

            rankingData.selectedRankingField = field;

            // ⭐ NEW: Store overlay reference if this is a climate overlay field
            if (overlay) {
                rankingData.selectedRankingFieldOverlay = overlay;
            } else {
                rankingData.selectedRankingFieldOverlay = undefined;
            }

            let foundIndex = rankingData.datasetFields.findIndex(
                (x) => x.id === field.id
            );
            if (foundIndex >= 0) {
                rankingData.datasetFields[foundIndex].selected = true;
            }
            rankingData.rankingDataSource.data = this.rankingModel.datapointObject.marksSelected(
                rankingData.rankingDataSource.data,
                field.id
            );
            let findExistingField = rankingData.selectedFields.find(
                (f) => f.id === rankingData.selectedRankingField.id
            );
            if (findExistingField) {
                let index = rankingData.datasetFields.findIndex(
                    (x) => x.id === field.id
                );
                rankingData.selectedFields.splice(index, 1);
            }
        } else {
            rankingData.selectedRankingField = undefined;
            rankingData.selectedRankingFieldOverlay = undefined;  // ⭐ NEW: Clear overlay reference
            let foundIndex = rankingData.datasetFields.findIndex(
                (x) => x.id === field.id
            );
            if (foundIndex >= 0) {
                rankingData.datasetFields[foundIndex].selected = false;
            }
            this.rankingModel.datapointObject.clearAllSelected(rankingData.rankingDataSource.data);
        }
    }

    onRankingFormulaSelection(
        selected: boolean,
        formula: any,
        counter: number,
        columnNumber: number
    ) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        let rankingData = selectedColumnData[counter];

        if (selected) {
            // Clear location selection when formula is selected
            rankingData.selectedRankingField = undefined;
            rankingData.datasetFields.forEach((f) => (f.selected = false));
            this.rankingModel.datapointObject.clearAllSelected(rankingData.rankingDataSource.data);

            rankingData.selectedFormula = formula;
            rankingData.rankingDataSource.data = this.rankingModel.datapointObject.marksSelected(
                rankingData.rankingDataSource.data,
                formula.id
            );
        } else {
            rankingData.selectedFormula = undefined;
            this.rankingModel.datapointObject.clearAllSelected(rankingData.rankingDataSource.data);
        }
    }

    getDisabledRankingTreeNode(node: any, data: any): boolean {
        if (!isUndefined(node.params)) {
            const field = node.params.field;
            if (node.params.callType === "formula") {
                return (
                    (data.selectedFormula &&
                        data.selectedFormula.id !== field.id) ||
                    data.selectedRankingField !== undefined
                );
            }

            const selectedIsOverlay = !!data.selectedRankingFieldOverlay || !!data.selectedRankingField?.datasetId;
            const selectedOverlayId = data.selectedRankingFieldOverlay?.id || data.selectedRankingField?.datasetId;
            const currentIsOverlay = !!node.params.overlay;
            const currentOverlayId = node.params.overlay?.id;

            if (data.selectedFormula !== undefined) {
                return true;
            }

            if (data.selectedRankingField) {
                if (selectedIsOverlay && currentIsOverlay) {
                    return !(selectedOverlayId === currentOverlayId && data.selectedRankingField?.id === field.id);
                }
                if (selectedIsOverlay !== currentIsOverlay) {
                    return true;
                }
                return data.selectedRankingField?.id !== field.id;
            }
        }
        return false;
    }

    onRankingFieldModelChangeEvent(
        node: any,
        data: any,
        counter: number,
        columnNumber: number
    ) {
        if (!isUndefined(node.params)) {
            if (node.params.callType === "formula") {
                this.onRankingFormulaSelection(node.selected, node.params?.field, counter, columnNumber);
                this.changeDetector.detectChanges();
                return;
            }

            const isOverlayNode = !!node.params?.overlay;
            const willSelect = !!node.selected; // capture before any clearing that mutates nodes

            if (!isOverlayNode) {
                // Primary dataset ranking field
                this.onRankingFieldSelection(willSelect, node.params?.field, counter, columnNumber);
                if (willSelect) {
                    data.rankingDataSource.data = this.rankingModel.datapointObject.marksSelected(
                        data.rankingDataSource.data,
                        node.params?.field?.id
                    );
                } else {
                    // Deselect: clear any marks
                    this.rankingModel.datapointObject.clearAllSelected(data.rankingDataSource.data);
                }
            } else {
                // Overlay ranking field
                if (willSelect) {
                    data.selectedFormula = undefined;
                    this.rankingModel.datapointObject.clearAllSelected(data.rankingDataSource.data);
                }
                this.onRankingFieldSelection(willSelect, node.params?.field, counter, columnNumber, node.params?.overlay);
                if (willSelect) {
                    // Re-assert selection on the clicked node after clearing
                    node.selected = true;
                    data.rankingDataSource.data = this.rankingModel.datapointObject.marksSelected(
                        data.rankingDataSource.data,
                        node.params?.field?.id
                    );
                } else {
                    // Deselect: clear any marks
                    this.rankingModel.datapointObject.clearAllSelected(data.rankingDataSource.data);
                }
            }
            // Ensure disabled states refresh immediately after selection changes
            this.changeDetector.detectChanges();
        }
    }

    generateRankingReport(report: any) {
        report.selectedGroups = AnalyticsUtils.getSelectedGroupsForRanking(report);
        let abc = this.rankingModel.generateReport(
            report,
            this.dataset,
            this.selectedGroupIds,
            this.isComparisonModeActivated
        );
    }

    isNotAllDatasetSelected(
        fields: DatasetField[],
        isLocations?: boolean
    ): boolean {
        if (isLocations) {
            return (
                fields.filter(
                    (field) =>
                        !field.selected &&
                        field.scope === this.datasetScope.INTERNAL &&
                        field.id !== "created_on" &&
                        field.id !== "updated_on"
                ).length > 0
            );
        } else {
            return fields.filter((field) => !field.selected).length > 0;
        }
    }

    onRankingFieldsMenuClick(
        fieldSelected: boolean,
        field: DatasetField,
        report: any,
        overlay?: Dataset
    ) {
        // Ensure structure exists
        if (!report.selectedFieldsByDataset) {
            report.selectedFieldsByDataset = new Map<string, DatasetField[]>();
        }

        // If this is an overlay column, store under selectedFieldsByDataset keyed by dataset id
        if (overlay && overlay.id) {
            const datasetId = overlay.id;
            let fieldsForDataset = report.selectedFieldsByDataset.get(datasetId);
            if (!fieldsForDataset) {
                fieldsForDataset = [];
                report.selectedFieldsByDataset.set(datasetId, fieldsForDataset);
            }

            if (fieldSelected) {
                const exists = fieldsForDataset.some(f => f.id === field.id);
                if (!exists) {
                    fieldsForDataset.push(field);
                }
            } else {
                const filtered = fieldsForDataset.filter(f => f.id !== field.id);
                if (filtered.length > 0) {
                    report.selectedFieldsByDataset.set(datasetId, filtered);
                } else {
                    report.selectedFieldsByDataset.delete(datasetId);
                }
            }
            return;
        }

        // Primary dataset field: keep existing behavior
        if (fieldSelected) {
            // Avoid duplicates just in case
            const exists = report.selectedFields.some((f: DatasetField) => f.id === field.id);
            if (!exists) {
                report.selectedFields.push(field);
            }
        } else {
            report.selectedFields = report.selectedFields.filter((f: DatasetField) => f.id !== field.id);
        }
    }

    // Cross-disable: if a primary dataset field is selected in columns, disable it in ranking menu
    // Only applies to primary location fields, not overlays
    isRankingNodeDisabledByColumns(node: any, report: any): boolean {
        if (!node || !node.params || node.params.overlay) {
            return false; // overlays are not cross-disabled with columns
        }
        const field: DatasetField = node.params.field;
        if (!field) {
            return false;
        }
        // Do not disable the currently selected ranking field itself
        if (report.selectedRankingField && report.selectedRankingField.id === field.id) {
            return false;
        }
        // Only disable if ranking field is NOT an overlay (i.e., it's a primary field)
        if (report.selectedRankingField && report.selectedRankingFieldOverlay) {
            return false; // ranking field is an overlay, so don't cross-disable
        }
        return report.selectedFields && report.selectedFields.some((f: DatasetField) => f.id === field.id);
    }

    // Cross-disable: if a primary dataset field is selected as ranking field, disable it in columns menu
    // Only applies to primary location fields, not overlays
    isColumnsNodeDisabledByRanking(node: any, report: any): boolean {
        if (!node || !node.params || node.params.overlay) {
            return false; // overlays are not cross-disabled with ranking
        }
        const field: DatasetField = node.params.field;
        if (!field || !report.selectedRankingField) {
            return false;
        }
        // Do not disable the currently selected ranking field itself
        if (report.selectedRankingField.id === field.id) {
            return false;
        }
        // Only disable if ranking field is NOT an overlay (i.e., it's a primary field)
        if (report.selectedRankingFieldOverlay) {
            return false; // ranking field is an overlay, so don't cross-disable
        }
        return report.selectedRankingField.id === field.id;
    }

    groupByNriFields(nriFields) {
        const groupBy = (array, key) => {
            // Return the end result
            return array.reduce((result, currentValue) => {
                // If an array already present for key, push it to the array. Else create an array and push the object
                let symbol = null;
                if (currentValue[key].trim().split("-").length > 1) {
                    symbol = "-";
                } else if (currentValue[key].trim().split("–").length > 1) {
                    symbol = "–";
                }
                if (isNullOrUndefined(symbol)) {
                    (result[currentValue[key].trim()] =
                        result[currentValue[key].trim()] || []).push({
                        name: currentValue[key].trim(),
                        child: currentValue,
                    });
                } else {
                    (result[currentValue[key].trim().split(symbol)[0].trim()] =
                        result[
                            currentValue[key].trim().split(symbol)[0].trim()
                        ] || []).push({
                        name: currentValue[key].trim().split(symbol)[1],
                        child: currentValue,
                    });
                }
                // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
                return result;
            }, {}); // empty object is the initial value for result object
        };
        const groupByObjectResponse = groupBy(nriFields, "name");
        let tempArray = [];
        let nriSummaryArray = [
            { name: "NRI Summary", isParentSelected: true, child: [] },
        ];
        Object.keys(groupByObjectResponse).map(function (key) {
            let nameSplitValue = key.split(" ");
            groupByObjectResponse[key][0].child.isProjected = true;
            if (
                [
                    TessadataNriFields.SUMMARY_SOVI_RATING,
                    TessadataNriFields.SUMMARY_RESL_RATING,
                ].includes(groupByObjectResponse[key][0].child.id)
            ) {
                nriSummaryArray[0].child.push({
                    name:
                        nameSplitValue[1] + " " + nameSplitValue[2] + " Rating",
                    child: groupByObjectResponse[key][0].child,
                });
            } else if (
                groupByObjectResponse[key][0].child.id ==
                TessadataNriFields.SUMMARY_EAL_RATING
            ) {
                nriSummaryArray[0].child.push({
                    name: nameSplitValue[1] + " Rating",
                    child: groupByObjectResponse[key][0].child,
                });
            } else if (
                groupByObjectResponse[key][0].child.id ==
                TessadataNriFields.SUMMARY_RISK_RATING
            ) {
                nriSummaryArray[0].child.push({
                    name: "Overall " + nameSplitValue[1],
                    child: groupByObjectResponse[key][0].child,
                });
            } else {
                tempArray.push({
                    name: key,
                    isParentSelected: true,
                    child: groupByObjectResponse[key],
                });
                return tempArray;
            }
        });

        if (nriSummaryArray[0].child.length > 0) {
            tempArray = [...nriSummaryArray, ...tempArray];
        }
        return tempArray;
    }

    // Tree code - start
    hasChild = (_: number, node: TreeStructure) =>
        !!node.children && node.children.length > 0;
    setParent(data, parent) {
        data.parent = parent;
        if (data.children) {
            data.children.forEach((x) => {
                this.setParent(x, data);
            });
        }
    }

    checkAllParents(node, treeControl) {
        if (node.parent) {
            const descendants = treeControl.getDescendants(node.parent);
            node.parent.selected = descendants.every((child) => child.selected);
            node.parent.indeterminate = descendants.some(
                (child) => child.selected
            );
            this.checkAllParents(node.parent, treeControl);
        }
    }
    todoItemSelectionToggle(checked, node, treeControl) {
        node.selected = checked;
        if (node.children) {
            node.children.forEach((x) => {
                this.todoItemSelectionToggle(checked, x, treeControl);
            });
        }
        this.checkAllParents(node, treeControl);
    }
    // Tree code - end

    sortData(sort: Sort, counter: number, reportType: ReportType, columnNumber: number) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        if (reportType === ReportType.AGGREGATE) {
            selectedColumnData = this.aggregateModel.sortData(sort, selectedColumnData[counter], this.dataset);
        } else if (reportType === ReportType.AVERAGE) {
            selectedColumnData = this.aggregateModel.sortData(sort, selectedColumnData[counter], this.dataset);
        } else if (reportType === ReportType.COUNT) {
            selectedColumnData = this.countModel.sortData(sort, selectedColumnData[counter]);
        } else if (reportType === ReportType.RANKING) {
            selectedColumnData = this.rankingModel.sortData(sort, selectedColumnData[counter]);
        }
        this.updateWorkspaceItemName(sort, counter, columnNumber);
    }

    fetchDashboardWorkspaceItems() {
        this.workspaceItemService
            .getAllWorkspaceItemsForUser(
                this.dataset.id,
                WorkspaceItemType.DASHBOARD
            )
            .subscribe((items) => {
                this.dashboardWorkspaceItems = items;
                this.dashboardWorkspaceItems.forEach((item) => {
                    if (
                        this.userStateService.isSuperadmin ||
                        this.userStateService.isAccountAdmin(
                            this.dataset.accountID
                        )
                    ) {
                        item.isDeletable = true;
                    } else {
                        if (item.access === WorkspaceItemAccess.MEMBER) {
                            item.isDeletable = true;
                        }
                    }
                });
            });
    }

    saveWorkspaceItemToDashboard(i: number) {
        const dashboardReportItem = [];
        dashboardReportItem.push(
            this.prepareSpecificWorkspaceItemInfo(this.analyticData[i])
        );

        this.workspaceIemDialog.open(
            dashboardReportItem,
            WorkspaceItemType.DASHBOARD,
            true,
            true
        );
    }

    saveAsWorkspaceItemToDashboard(i: number, columnNumber: number) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        const dashboardReportItem = [];
        dashboardReportItem.push(
            this.prepareSpecificWorkspaceItemInfo(selectedColumnData[i])
        );

        this.workspaceIemDialog.open(
            dashboardReportItem,
            this.getActiveDasboardType(),
            false,
            true
        );
    }

    private prepareSpecificWorkspaceItemInfo(report) {
        let formattedReportData: any = {};
        switch (report.reportType) {
            case ReportType.AGGREGATE:
                let aggregateReportComponent = report;
                let jsonObject: any = {};
                jsonObject[this.activeDataset.id] =
                    report.selectedBreakdownFieldsByDataset.get(
                        this.activeDataset.id
                    );

                formattedReportData = {
                    id: RandomUtils.generateUUID(),
                    name: aggregateReportComponent.reportName || "",
                    selectedAggregateField:
                        aggregateReportComponent.selectedFields,
                    selectedBreakdownFieldsByDataset: jsonObject,
                    type: ReportType.AGGREGATE,
                };

                if (aggregateReportComponent.selectedFormula) {
                    formattedReportData.selectedFormula =
                        aggregateReportComponent.selectedFormula;
                } else {
                    formattedReportData.selectedAggregateField =
                        aggregateReportComponent.selectedAggregateField;
                }
                formattedReportData.reportType = aggregateReportComponent.reportType;
                formattedReportData.reportSubType = aggregateReportComponent.reportSubType;
                formattedReportData.chartDisplayType = aggregateReportComponent.chartDisplayType;
                if(this.isComparisonModeActivated) {
                    formattedReportData.compareGroupId = [AnalyticsUtils.getSelectedNodes(aggregateReportComponent._compareGroupsStrcuture)[0].id];
                    formattedReportData.withGroupId = [AnalyticsUtils.getSelectedNodes(aggregateReportComponent._withGroupsStrcuture)[0].id];
                }
                break;
            case ReportType.RANKING:
                let rankingReportComponent = report;
                formattedReportData = {
                    id: RandomUtils.generateUUID(),
                    name: rankingReportComponent.reportName || "",
                    selectedFields: rankingReportComponent.selectedFields,
                    noOfItems: rankingReportComponent.noOfItems,
                    type: ReportType.RANKING,
                };

                if (rankingReportComponent.selectedFormula) {
                    formattedReportData.selectedFormula =
                        rankingReportComponent.selectedFormula;
                } else {
                    // Deep clone to avoid reference issues
                    formattedReportData.selectedRankingField =
                        JSON.parse(JSON.stringify(rankingReportComponent.selectedRankingField));

                    // ⭐ NEW: Embed overlay dataset ID directly in field object
                    if (rankingReportComponent.selectedRankingFieldOverlay) {
                        formattedReportData.selectedRankingField.datasetId =
                            rankingReportComponent.selectedRankingFieldOverlay.id;
                    }
                }

                // ⭐ NEW: Save selectedFieldsByDataset Map (climate overlay column fields)
                if (rankingReportComponent.selectedFieldsByDataset &&
                    rankingReportComponent.selectedFieldsByDataset.size > 0) {
                    let rankingJsonObject = {};
                    rankingReportComponent.selectedFieldsByDataset.forEach((fields, datasetId) => {
                        // Deep clone fields and embed datasetId in each field
                        const fieldsWithDatasetId = fields.map(field => {
                            const fieldCopy = JSON.parse(JSON.stringify(field));
                            fieldCopy.datasetId = datasetId;
                            return fieldCopy;
                        });
                        rankingJsonObject[datasetId] = fieldsWithDatasetId;
                    });
                    formattedReportData.selectedFieldsByDataset = rankingJsonObject;
                }

                formattedReportData.reportType = rankingReportComponent.reportType;
                formattedReportData.reportSubType = rankingReportComponent.reportSubType;
                formattedReportData.chartDisplayType = rankingReportComponent.chartDisplayType;
                if(this.isComparisonModeActivated) {
                    formattedReportData.compareGroupId = [AnalyticsUtils.getSelectedNodes(rankingReportComponent._compareGroupsStrcuture)[0].id];
                    formattedReportData.withGroupId = [AnalyticsUtils.getSelectedNodes(rankingReportComponent._withGroupsStrcuture)[0].id];

                }
                break;
            case ReportType.COUNT:
                let countReportComponent = report;
                const keyValueArray: any[] = Array.from(report.selectedFieldsByDataset.entries());
                const keyValuePairs = {};
                keyValueArray.forEach(([key, value]) => {
                    keyValuePairs[key] = value;
                });
                formattedReportData = {
                    id: RandomUtils.generateUUID(),
                    name: report.reportName || "",
                    selectedFieldsByDataset: keyValuePairs,
                    type: ReportType.COUNT,
                };
                formattedReportData.reportType = countReportComponent.reportType;
                formattedReportData.reportSubType = countReportComponent.reportSubType;
                formattedReportData.chartDisplayType = countReportComponent.chartDisplayType;
                if(this.isComparisonModeActivated) {
                    formattedReportData.compareGroupId = [AnalyticsUtils.getSelectedNodes(countReportComponent._compareGroupsStrcuture)[0].id];
                    formattedReportData.withGroupId = [AnalyticsUtils.getSelectedNodes(countReportComponent._withGroupsStrcuture)[0].id];
                }
                break;
            case ReportType.AVERAGE:
                let averageReportComponent = report;
                let averageJsonObject: any = {};

                // Convert Map to plain object
                if (report.selectedBreakdownFieldsByDataset instanceof Map) {
                    report.selectedBreakdownFieldsByDataset.forEach((value, key) => {
                        averageJsonObject[key] = value;
                    });
                } else {
                    // Already an object (when loading from saved data)
                    averageJsonObject = report.selectedBreakdownFieldsByDataset;
                }

                formattedReportData = {
                    id: RandomUtils.generateUUID(),
                    name: averageReportComponent.reportName || "",
                    selectedBreakdownFieldsByDataset: averageJsonObject,
                    type: ReportType.AVERAGE,
                };

                if (averageReportComponent.selectedFormula) {
                    formattedReportData.selectedFormula =
                        averageReportComponent.selectedFormula;
                } else {
                    formattedReportData.selectedAggregateField =
                        averageReportComponent.selectedAggregateField;
                }
                formattedReportData.reportType = averageReportComponent.reportType;
                formattedReportData.reportSubType = averageReportComponent.reportSubType;
                formattedReportData.chartDisplayType = averageReportComponent.chartDisplayType;
                if(this.isComparisonModeActivated) {
                    formattedReportData.compareGroupId = [AnalyticsUtils.getSelectedNodes(averageReportComponent._compareGroupsStrcuture)[0].id];
                    formattedReportData.withGroupId = [AnalyticsUtils.getSelectedNodes(averageReportComponent._withGroupsStrcuture)[0].id];
                }
                break;
        }

        return formattedReportData;
    }

    downloadReport(reportElementIndex: number, columnNumber: number) {
        this.downloadModel.process(true, reportElementIndex, this.activeDataset, this.getSelectedGroupIds(), this.getAnalyticDataUsingCloumnNumber(columnNumber))
        // const component = this.analyticData[reportElementIndex];
        // let downloadItems: DownloadReportItem[] = [];
        // let reportHasTwoDimensionPieChart = false;

        // if (component) {
        //     if (
        //         component.displayType === ReportDisplayType.PIE_CHART &&
        //         component.isTwoDimensionReport
        //     ) {
        //         reportHasTwoDimensionPieChart = true;
        //     }

        //     let reportDownloadRequest: DownloadReportItem =
        //         this.getReportDownloadRequest(component);

        //     if (reportDownloadRequest) {
        //         downloadItems.push(reportDownloadRequest);
        //     }
        // }

        // let reportRequest: DownloadReportRequest = {
        //     items: downloadItems,
        // };

        // let downloadRequest: DownloadDatapointRequest = {
        //     reportRequest: reportRequest,
        //     filter: this.getActiveFilter(),
        //     timezone: Constants.DEFAULT_TIMEZONE,
        //     dateFormat: Constants.DEFAULT_DATE_FORMAT,
        //     outputFileType: DownloadFileType.XLSX,
        // };

        // if (reportHasTwoDimensionPieChart) {
        //     const dialogRef = this.dialog.open(DialogComponent, {
        //         data: new DialogModel(
        //             "Confirm Download",
        //             `Your pie chart has multiple criteria, but the spreadsheet download will only display one. We recommend downloading the bar charts instead.`,
        //             "Cancel",
        //             "Download"
        //         ),
        //     });
        //     dialogRef
        //         .afterClosed()
        //         .pipe(take(1))
        //         .subscribe((dialogResult) => {
        //             if (dialogResult) {
        //                 this.downloadReportFile(downloadRequest);
        //             }
        //         });
        // } else {
        //     this.downloadReportFile(downloadRequest);
        // }
    }

    private downloadReportFile(downloadRequest: DownloadDatapointRequest) {
        this.downloadService
            .downloadDatapoints(
                this.dataset.id,
                downloadRequest,
                "Analytics.xlsx"
            )
            .subscribe(
                (response) => {
                    AttachmentUtils.downloadFileWithName(
                        response,
                        "Analytics.xlsx"
                    );
                },
                (error) =>
                    this.notifService.error(
                        "Something went wrong during download"
                    )
            );
    }

    getActiveFilter() {
        return {
            datasetID: this.activeDataset.id,
            fields: [],
            groups: this.getSelectedGroupIds(),
            links: [],
        };
    }

    getSelectedGroupIds() {
        const accountId = +this.route.snapshot.paramMap.get('accountId');
        const key = getGroupsLocalStorageKey(accountId);
        let storedGroupIds: number[] = [];
        const saved = localStorage.getItem(key);
        if (saved) {
            storedGroupIds = JSON.parse(saved);
        }
        if (storedGroupIds.length > 0) {
            return storedGroupIds;
        }

        const selectedGroupsIds = this.selectedDropdownItems.map((item) => {
            return item.id;
        });
        return selectedGroupsIds || [];
    }

    getReportDownloadRequest(report): DownloadReportItem {
        if (report.reportSubType === ReportDisplayType.TABLE) {
            return report.tableDownloadRequest;
        } else if (
            report.reportSubType === ReportDisplayType.BAR_CHART ||
            report.reportSubType === ReportDisplayType.PIE_CHART
        ) {
            if (report.chartDownloadRequest) {
                if (report.reportSubType === ReportDisplayType.BAR_CHART) {
                    report.chartDownloadRequest.type =
                        DownloadItemReportType.AGGREGATE_BAR_CHART;
                } else if (report.reportSubType === ReportDisplayType.PIE_CHART) {
                    report.chartDownloadRequest.type =
                        DownloadItemReportType.AGGREGATE_PIE_CHART;
                }
            }
            return report.chartDownloadRequest;
        }
    }

    deleteWorkspaceItem(counter:number, columnNumber: number) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        const item: WorkspaceItem = selectedColumnData[counter];
        const dialogRef = this.dialog.open(DialogComponent, {
            data: new DialogModel(
                "Confirm Action",
                `Are you sure you want to delete "${item.reportName}"?`
            ),
        });
        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    this.workspaceItemService
                        .deleteWorkspaceItem(item.id)
                        .subscribe(
                            (success) => {
                                this.rightPanelCall(true);
                            },
                            (error) =>
                                this.notifService.error(error.error.message)
                        );
                }
            });
    }

    rightPanelCall(isShowDeleteNotification: boolean = false) {
        this.subscriptions.add(
            forkJoin(
                this.workspaceItemService.getAllWorkspaceItemsForUser(
                    this.dataset.id,
                    WorkspaceItemType.DASHBOARD
                ),
                this.workspaceItemService.getAllWorkspaceItemsForUser(
                    this.dataset.id,
                    WorkspaceItemType.FORMULA
                )
            ).subscribe(([analytics, formulas]) => {
                this._analytics = analytics;
                this._formulas = formulas;
                this.getAnalyticsFromServer();
                if (isShowDeleteNotification) {
                    this.notifService.success("Item was deleted successfully");
                }
            })
        );
    }

    indicatorsDrop(event: CdkDragDrop<string[]>) {
        moveItemInArray(
            this.sidebarDataValues,
            event.previousIndex,
            event.currentIndex
        );
        const idToSequenceMap = new Map<number, number>();

        this.sidebarDataValues.forEach((item, i) => {
            idToSequenceMap.set(item.id, i + 1);
        });

        this.indicatorsData.fields.forEach(item => {
            const sequence = idToSequenceMap.get(item.id);
            if (sequence) {
                item.sequence = sequence;
            }
        });
        const doSequencing = false;
       this.saveIndicatorsConfiguration(this.indicatorsData.fields, doSequencing);
    }

    reportDrop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            const previousItem = event.previousContainer.data[event.previousIndex];
            const currentItem = event.container.data[event.currentIndex];

            event.container.data[event.currentIndex] = previousItem;
            event.previousContainer.data[event.previousIndex] = currentItem;
        }
        if (this.hasAccess) {
            this.saveSequence();
        }
    }

    openAnalyticsPanel() {
        this.isAnalyticsPanelOpen = true;
        this.analyticsPanel = undefined;
        this.showAnalyticsPanel();
        const { componentRef } = this.analyticsPanel.instance;
        if (componentRef) {
            componentRef.instance.removeAllReports();
            componentRef.instance.initialize();
        }
    }

    analyticsPanel: ComponentRef<SidePanelComponent>;

    showAnalyticsPanel() {
        if (this.analyticsPanel) {
            this.analyticsPanel.instance.showPanel();
        } else {
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.analyticsPanel =
                this.sidePanelService.open<AnalitycsComponentType>(
                    SidePanels.ANALYTICS,
                    {
                        width: 500,
                        id: "analytics",
                        panelTitle: "Analytics",
                        resizeable: true,
                        panelIcon: "icon-analitycs",
                    },
                    {
                        dataset: this.dataset,
                        nriFields: this.tessadataFields.nriFields,
                        isDashboardCall: true,
                        climateOverlays: this.prepareClimateOverlays(),
                        isComparisonModeActivated: this.isComparisonModeActivated
                    }
                );

            this.workspaceItemService.isDashboardCallClose$.subscribe(
                (response) => {
                    this.isAnalyticsPanelOpen = false;
                    if (response) {
                        this.rightPanelCall();
                        this.analyticsPanel.instance.closePanel();
                    }
                }
            );
        }
    }

    ngOnDestroy(): void {
        if (this.analyticsPanel) {
            this.analyticsPanel.instance.closePanel();
            this.analyticsPanel = null;
        }
    }

    downloadPanel() {
        //         const pages = document.querySelector('.dashboard-main-content') as HTMLElement;
        //         let pdfOptions = {orientation: 'p', unit: 'px', format: [595, 842],  pagesplit: true};
        //         var element = document.getElementById('pdfTable');
        // var opt = {
        //   margin:       0.1,
        //   filename:     'myfile.pdf',
        //   image:        { type: 'jpeg', quality: 0.20 },
        //   html2canvas:  { scale: 2 },
        //   jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' }
        // };
        //  console.log(element);
        // // New Promise-based usage:
        // html2pdf().from(element).set(opt).save();
        //     let doc = new jsPDF(pdfOptions);
        // doc.addHTML(this.pdfTable.nativeElement, function() {
        //    doc.save("obrz.pdf");
        // });
        //     const doc = new jsPDF();
        // const pdfTable = this.pdfTable.nativeElement;
        // var html = htmlToPdfmake(pdfTable.innerHTML);
        // const documentDefinition = { content: html };
        // pdfMake.createPdf(documentDefinition).open();
        // const doc = new jsPDF(pdfOptions);
        //     var printDoc = new jsPDF();
        // printDoc.fromHTML(pages);
        // printDoc.autoPrint();
        // printDoc.output("dataurlnewwindow");
        // globalThis.html2canvas = html2canvas;
        // console.log(pages);
        //   doc.html(pages, {
        //     callback: (doc: jsPDF) => {
        //       doc.deletePage(doc.getNumberOfPages());
        //       doc.save('pdf-export');
        //     }
        //   });
        // const doc = new jsPDF();
        // const specialElementHandlers = {
        //   '#editor': function (element, renderer) {
        //     return true;
        //   }
        // };
        // // const content = this.htmlContent.nativeElement;
        // doc.fromHTML(pages, 15, 15, {
        //   'width': 190,
        //   'elementHandlers': specialElementHandlers
        // });
        // doc.save('document.pdf');
    }

    downloadDashboardPDF() {
        let downloadItems = [];
        let reportHasTwoDimensionPieChart = false;
        const sequencedAnalyticData = this.combineAnalyticsData();


        sequencedAnalyticData.forEach((component) => {
            if (component) {
                if (
                    component.reportSubType === ReportDisplayType.PIE_CHART &&
                    component.isTwoDimensionReport
                ) {
                    reportHasTwoDimensionPieChart = true;
                }

                let reportDownloadRequest =
                    this.getReportDownloadRequestForPDF(component);

                if (reportDownloadRequest) {
                    downloadItems.push(reportDownloadRequest);
                }
            }
        });

        let reportRequest: DownloadReportRequest = {
            items: downloadItems,
        };

        let downloadRequest: DownloadDatapointRequest = {
            reportRequest: reportRequest,
            filter: this.getActiveFilter(),
            timezone: Constants.DEFAULT_TIMEZONE,
            dateFormat: Constants.DEFAULT_DATE_FORMAT,
            outputFileType: DownloadFileType.PDF,
        };

        this.downloadDashboardPDFFile(downloadRequest);
    }

    private downloadDashboardPDFFile(
        downloadRequest: DownloadDatapointRequest
    ) {
        this.downloadService
            .downloadDashboardPDFFile(
                this.dataset.id,
                downloadRequest,
                "Analytics.pdf"
            )
            .subscribe(
                (response) => {
                    AttachmentUtils.downloadFileWithName(
                        response,
                        "Analytics.pdf"
                    );
                },
                (error) =>
                    this.notifService.error(
                        "Something went wrong during download"
                    )
            );
    }

    getReportDownloadRequestForPDF(report): DownloadReportItem {
        if (report.reportSubType === ReportDisplayType.TABLE) {
            return {
                id: report.id,
                reportViewType: ReportViewType.TABLE,
                chartViewType: ChartViewType.NONE,
                type: report.type,
                ...report.tableDownloadRequest,
            };
        } else if (
            report.reportSubType === ReportDisplayType.BAR_CHART ||
            report.reportSubType === ReportDisplayType.PIE_CHART
        ) {
            // delete report.chartDownloadRequest.type;
            if (report.chartDownloadRequest) {
                if (report.reportSubType === ReportDisplayType.BAR_CHART) {
                    report.chartDownloadRequest.type =
                        DownloadItemReportType.AGGREGATE_BAR_CHART;
                } else if (report.reportSubType === ReportDisplayType.PIE_CHART) {
                    report.chartDownloadRequest.type =
                        DownloadItemReportType.AGGREGATE_PIE_CHART;
                }
            }
            if (!report.chartDisplayType) {
                report.chartDownloadRequest.chartViewType = ChartViewType.NONE;
            } else {
                if (report.chartDisplayType === ChartDisplayType.AGGREGATE) {
                    report.chartDownloadRequest.chartViewType =
                        ChartViewType.AGGREGATE;
                    report.chartDownloadRequest.columns.value =
                    ChartDisplayLabel.AGGREGATE;
                } else if (report.chartDisplayType === ChartDisplayType.COUNT) {
                    report.chartDownloadRequest.chartViewType =
                        ChartViewType.COUNT;
                    report.chartDownloadRequest.columns.value =
                    ChartDisplayLabel.COUNT;
                } else if (report.chartDisplayType === ChartDisplayType.AVERAGE) {
                    report.chartDownloadRequest.chartViewType =
                        ChartViewType.AVERAGE;
                    report.chartDownloadRequest.columns.value =
                    ChartDisplayLabel.AVERAGE;
                }
            }

            return {
                id: report.id,
                reportViewType:
                    report.reportSubType === ReportDisplayType.BAR_CHART
                        ? ReportViewType.BAR_CHART
                        : ReportViewType.PIE_CHART,
                type: report.type,
                ...report.chartDownloadRequest,
            };
        }
    }

    validate(event: ResizeEvent): boolean {
        const MIN_DIMENSIONS_PX = 320;
        this.MIN_DIMENSIONS_PX = MIN_DIMENSIONS_PX;
        if (
            event.rectangle.width &&
            event.rectangle.height &&
            (event.rectangle.width < MIN_DIMENSIONS_PX ||
                event.rectangle.height < MIN_DIMENSIONS_PX)
        ) {
            return false;
        }
        return true;
    }

    onResizeEnd(event: ResizeEvent, reportElementIndex: number, columnNumber: number): void {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        let newWidth = event.rectangle.width;
        let newHeight = event.rectangle.height;

        if (event.edges.right || event.edges.left) {
            newHeight = this.calculateWidgetDimension(
                "height",
                event.rectangle.width
            );
        } else if (event.edges.bottom || event.edges.top) {
            newWidth = this.calculateWidgetDimension(
                "width",
                event.rectangle.height
            );
        }
        newWidth = newWidth > this.MIN_DIMENSIONS_PX ? newWidth : this.MIN_DIMENSIONS_PX;
        newHeight = newHeight > this.MIN_DIMENSIONS_PX ? newHeight : this.MIN_DIMENSIONS_PX;

        selectedColumnData.forEach(element => {
            if(!element && !element.style){
                element.style = {
                    position: "relative",
                    width: `500px`,
                    height: this.calculateWidgetDimension(
                        "height",
                        500
                    ),
                }
            }
        });

        selectedColumnData[reportElementIndex].style = {
            position: "relative",
            width: `${newWidth}px`,
            height: `${newHeight}px`,
        };
        selectedColumnData[reportElementIndex].isResizing = true;

        this.repaintDOM(reportElementIndex);
    }

    calculateWidgetDimension(
        dimension: "width" | "height",
        value: number
    ): number {
        const aspectRatio = 5 / 7;
        if (dimension === "width") {
            return value / aspectRatio;
        } else if (dimension === "height") {
            return value * aspectRatio;
        }
    }

    repaintDOM(reportElementIndex: number) {
        this.analyticsColumnOne.forEach(analytic => {
            if(analytic){
                let prevDisplayType = analytic?.reportSubType;
                analytic.reportSubType = ReportDisplayType.TABLE;
                setTimeout(() => {
                    analytic.reportSubType = prevDisplayType;
                    if(this.analyticsColumnOne[reportElementIndex]){
                        this.analyticsColumnOne[reportElementIndex].isResizing = false;
                    }
                }, 1000);
            }
        });

        this.analyticsColumnTwo.forEach(analytic => {
            if(analytic){
            let prevDisplayType = analytic?.reportSubType;
            analytic.reportSubType = ReportDisplayType.TABLE;
            setTimeout(() => {
                analytic.reportSubType = prevDisplayType;
                if(this.analyticsColumnTwo[reportElementIndex]){
                    this.analyticsColumnTwo[reportElementIndex].isResizing = false;
                }
            }, 1000);
            }
        });

        this.analyticsColumnThree.forEach(analytic => {
            if(analytic){
            let prevDisplayType = analytic?.reportSubType;
                analytic.reportSubType = ReportDisplayType.TABLE;
                setTimeout(() => {
                    analytic.reportSubType = prevDisplayType;
                    if(this.analyticsColumnThree[reportElementIndex]){
                        this.analyticsColumnThree[reportElementIndex].isResizing = false;
                    }
                    if(this.analyticData[reportElementIndex]){
                        this.analyticData[reportElementIndex].isResizing = false;
                    }
                }, 1000);
            }
        });
    }

    swapDynamicStyle(previousIndex: number, currentIndex: number): void {
        // // Swap the values using a temporary variable
        // const temp = this.reportElemetDynamicStyle[previousIndex];
        // this.reportElemetDynamicStyle[previousIndex] =
        //     this.reportElemetDynamicStyle[currentIndex];
        // this.reportElemetDynamicStyle[currentIndex] = temp;
    }

    saveState(i: number, columnNumber: number) {
        if (this.hasAccess) {
            let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);

            this._analytics.forEach(element => {
                if (element.id == selectedColumnData[i].id) {
                    element.reportType =  selectedColumnData[i].reportType,
                    element.reportSubType = selectedColumnData[i].reportSubType,
                    element.chartDisplayType = selectedColumnData[i].chartDisplayType
                }
            });
            let request: UpdateWorkspaceItemStateRequest = {
                workspaceItemID: selectedColumnData[i].id,
                reportType: selectedColumnData[i].reportType,
                accountId: this.datapointsPageStateService.activeAccount.id,
                reportSubType: selectedColumnData[i].reportSubType,
                chartDisplayType: selectedColumnData[i].chartDisplayType
            };
            this.workspaceItemService.updateWorkspaceItemState(request).subscribe(response => {
            });
        }
    }

    saveSequence() {
        let request: UpdateWorkspaceItemSequenceRequest = {
            accountId: this.dataset.accountID,
            data: []
        };
        const sequencedAnalyticData = this.combineAnalyticsData();
        sequencedAnalyticData.forEach((element, index) => {
                if(element){
                    request.data.push({
                    workspaceItemId: element.id,
                    sequence: index + 1
                });
                this.workspaceItemService.updateWorkspaceItemSequence(request).subscribe(response => {
                });
            }
        })
    }

    updateWorkspaceItemName($event, counter: number, columnNumber: number) {
        if (this.hasAccess) {
            let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
            let report = this._analytics.find(element => element.id === selectedColumnData[counter].id);
            const data = JSON.parse(report.data);
            if (!isUndefined(data[0])) {
                data[0].sort = selectedColumnData[counter].sort;
            }
            if (report !== undefined) {
                const reportName = selectedColumnData[counter].reportName;
                let request: UpdateWorkspaceItemRequest = {
                    id: report.id,
                    data: JSON.stringify(data),
                    access: report.access,
                    name: reportName,
                    reportType: selectedColumnData[counter].reportType,
                    reportSubType: selectedColumnData[counter].reportSubType,
                    chartDisplayType: selectedColumnData[counter].chartDisplayType
                };
                this.workspaceItemService.updateWorkspaceItem(request).subscribe(
                    (success) => {
                        this.getAnalyticDataUsingCloumnNumber(columnNumber)[counter].tableDownloadRequest.title = request.name;
                        if(isUndefined($event.active)) {
                            this.notifService.success(
                                "View was successfully updated"
                            );
                        }
                    },
                    (error) => this.notifService.error(error.error.message)
                );
            } else {
                console.log("report data not found.")
            }
        }
    }

    divideAnalyticsData(){
        const numColumns = 3;

        this.analyticData.forEach((analytic, i) => {
            const columnIndex = i % numColumns;
            switch (columnIndex) {
                case 0:
                this.analyticsColumnOne.push(analytic);
                break;
                case 1:
                this.analyticsColumnTwo.push(analytic);
                break;
                case 2:
                this.analyticsColumnThree.push(analytic);
                break;
            }
        });
        this.isAnalyticsPrepared = true;
    }

    getAnalyticDataUsingCloumnNumber(columnNumber: number){
        switch (columnNumber) {
            case 1:
                return this.analyticsColumnOne
            case 2:
                return this.analyticsColumnTwo
            case 3:
                return this.analyticsColumnThree
            default:
                return this.analyticData
        }
    }

    combineAnalyticsData() {
        const sequencedAnalyticData = [];
        const maxLength = Math.max(
          this.analyticsColumnOne.length,
          this.analyticsColumnTwo.length,
          this.analyticsColumnThree.length
        );

        for (let i = 0; i < maxLength; i++) {
          if (i < this.analyticsColumnOne.length) {
            sequencedAnalyticData.push(this.analyticsColumnOne[i]);
          }
          if (i < this.analyticsColumnTwo.length) {
            sequencedAnalyticData.push(this.analyticsColumnTwo[i]);
          }
          if (i < this.analyticsColumnThree.length) {
            sequencedAnalyticData.push(this.analyticsColumnThree[i]);
          }
        }

        return sequencedAnalyticData;
    }

    openIndicatorsEditDialog() {
        this.floatingFieldsDataSubscription.unsubscribe();
        this.floatingFieldsDataSubscription = new Subscription();
        const allIndicators = ObjectUtils.clone(this.indicatorsData.fields);

        // Create a set of formula IDs for quick lookup
        // Convert to numbers to ensure consistent comparison
        const formulaIds = new Set(this._formulas?.map(f => Number(f.id)) || []);

        // Filter indicators: if type is set, use it; otherwise check against known formulas
        const locationIndicators = allIndicators.filter(field => {
            if (field.type === 'FORMULA') return false;
            if (field.type === 'LOCATION') return true;
            // If no type set, check if ID matches a known formula
            return !formulaIds.has(Number(field.id));
        });

        const formulaIndicators = allIndicators.filter(field => {
            if (field.type === 'FORMULA') return formulaIds.has(Number(field.id));
            if (field.type === 'LOCATION') return false;
            // If no type set, check if ID matches a known formula
            return formulaIds.has(Number(field.id));
        });

        const dialogRef = this.dialog.open(IndicatorsEditDialog, {
            height: '400px',
            width: '800px',
            data: {
                locations: locationIndicators,
                formulas: formulaIndicators
            },
        });

        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((result) => {
                if (result) {
                    const combinedIndicators = result.locations.concat(result.formulas);
                    this.loadReportData(combinedIndicators);
                    this.saveIndicatorsConfiguration(combinedIndicators);
                }
            });
    }

    saveIndicatorsConfiguration(dialogResponse: IndicatorField[], doSequencing = true) {
        if(doSequencing){
            let maxExistingSequence = 0;
            this.indicatorsData.fields = dialogResponse;

            this.indicatorsData.fields.forEach((indicator) => {
                if(!indicator.isIndicators){
                    indicator.sequence = 0;
                }

                if(indicator.sequence > maxExistingSequence){
                    maxExistingSequence = indicator.sequence;
                }
            });

            this.indicatorsData.fields.sort((a, b) => a.sequence - b.sequence);

            this.indicatorsData.fields.forEach((indicator) => {
                if(indicator.isIndicators && !indicator.sequence){
                    indicator.sequence = ++maxExistingSequence;
                }
            });
        }
        this.dashboardService.updateDashboardIndicators(this.indicatorsData).subscribe((success) => {
            this.notifService.success("Indicators updated successfully");
        })
    }

    undoResize(){
        this.analyticsColumnOne.forEach(analytic => {
            if(analytic){
                analytic.style = null;
            }
        });
        this.analyticsColumnTwo.forEach(analytic => {
            if(analytic){
                analytic.style = null;
            }
        });
        this.analyticsColumnThree.forEach(analytic => {
            if(analytic){
                analytic.style = null;
            }
        });

        this.repaintDOM(this.analyticsColumnThree[this.analyticsColumnOne.length - 1]);
    }

   /* isTensorFlight(key: string) {
        return key.toUpperCase() === "TENSORFLIGHT";
    } */

    isE2Value(key: string) {
        return key.toUpperCase() === "E2VALUE";
    }


    dynamicFilterMenuEmitter($event,counter: number, columnNumber: number) {
        this.onCountsFieldsMenuClick($event.event, $event.dataset, $event.field, counter, columnNumber);
    }

    get DatasetGeometryType() {
        return DatasetGeometryType;
    }

    onCountsFieldsMenuClick(
        fieldSelected: boolean,
        dataset: Dataset,
        field: DatasetField,
        counter: number,
        columnNumber: number,
    ) {
        let selectedColumnData = this.getAnalyticDataUsingCloumnNumber(columnNumber);
        let countReport = selectedColumnData[counter];

        let datasetFields = countReport.selectedFieldsByDataset.get(dataset.id);
        if (!datasetFields) {
            datasetFields = [],
            countReport.selectedFieldsByDataset.set(
                dataset.id,
                datasetFields
            );
        }

        if (fieldSelected) {
            datasetFields.push(field);
            countReport.selectedFieldsByDatasetCount++;
        } else {
            countReport.selectedFieldsByDataset.set(
                dataset.id,
                datasetFields.filter((f) => f.id !== field.id)
            );
            countReport.selectedFieldsByDatasetCount--;
        }
    }

    getDisplayName(node) {
        return new Datapoints().getDisplayName(node);
    }

    /**
     * Check if a ranking field should be disabled
     * For climate overlays: Disable if a different field is selected OR if same field but different overlay
     * For primary dataset: Standard field ID check
     */
    isRankingFieldDisabled(report: any, node: any): boolean {
        // If no ranking field selected, enable all
        if (!report.selectedRankingField) {
            return false;
        }

        const selectedField = report.selectedRankingField;
        const currentField = node.params?.field;

        if (!currentField) {
            return false;
        }

        // Check if selected field is from climate overlay
        const selectedIsOverlay = report.selectedRankingFieldOverlay || selectedField.datasetId;
        const currentIsOverlay = node.params?.overlay;

        if (selectedIsOverlay && currentIsOverlay) {
            // Both are overlays - enable only if SAME overlay AND SAME field
            const selectedOverlayId = report.selectedRankingFieldOverlay?.id || selectedField.datasetId;
            const currentOverlayId = node.params.overlay.id;

            return !(
                selectedOverlayId === currentOverlayId &&
                selectedField.id === currentField.id
            );
        } else if (selectedIsOverlay && !currentIsOverlay) {
            // Selected is overlay, current is primary dataset - disable primary dataset field
            return true;
        } else if (!selectedIsOverlay && currentIsOverlay) {
            // Selected is primary dataset, current is overlay - disable overlay field
            return true;
        } else {
            // Both are primary dataset - standard check
            return selectedField.id !== currentField.id;
        }
    }

    getDisabledTreeNode(node, data) {
        if (!isUndefined(node.params)) {
            const field = node.params.field;
            if (node.params.callType == 'dataset') {
                return (data.selectedAggregateField && data.selectedAggregateField?.id !== field.id) || data.selectedFormula !== undefined;
            } else if (node.params.callType == 'formula') {
                return (data.selectedFormula && data.selectedFormula.id !== field.id) || data.selectedAggregateField !== undefined;
            } else {
                return false;
            }
        }
    }
    sortFilterAccountOverlays(res) {
        const information = res.filter((element)=>element.group.name.toLowerCase()=="information");
        res.forEach((element)=>{
            if(element.children.length){
              element.children.sort((item1,
              item2)=>{
                if(item1&&item1.group.name&&item2&&item2.group.name){
                  return item1.group.name.trim().toLowerCase().localeCompare(item2.group.name.trim().toLowerCase());
                }
              });
            }
          });
          res.sort((a, b)=>a.group.name>b.group.name?-1: 1);
          let index = res.findIndex((group)=>group.group.name.toLowerCase()==="information");
          if(index!==-1){
            res.splice(index,
            1);
          }
          let filterAccountOverlays = res;//HidePrivateOverlays-ifexists-foranotsuperadminuseruntilBEcodeforthiswillbeimplemented
          if(!this.userStateService.isSuperadmin){
            let index = filterAccountOverlays.findIndex((group)=>group.group.name==="Private Overlays");
            if(index!==-1) {
              filterAccountOverlays.splice(index,
              1);
            }
          }
        return !isUndefined(information) ? [ ...filterAccountOverlays, ...information] : filterAccountOverlays;
    }
    prepareFilterAcccountOverlays(overlays) {
        overlays.forEach((element, key) => {
            this.parentOverlay = element;
            if (element.children.length <= 0 && element.overlays.length <= 0) {
                overlays.splice(key, 1);
                return;
            } else if (element.children.length > 0) {
                this.recursiveFilterAccountOverlay(element);
            }
            if (element.children.length <= 0 && element.overlays.length <= 0) {
                overlays.splice(key, 1);
            }
        });
        return overlays;
    }
    recursiveFilterAccountOverlay(element) {
        if (element.children.length) {
            let groupIds = [];
            element.children.forEach((sub_element, key) => {
                if (
                    sub_element.children.length <= 0 &&
                    sub_element.overlays.length <= 0
                ) {
                    groupIds.push(sub_element.group.id);
                } else if (sub_element.children.length > 0) {
                    element.children = element.children.filter(
                        (params) => !groupIds.includes(params.group.id)
                    );
                    this.recursiveFilterAccountOverlay(sub_element);
                    return;
                }
            });
            if (groupIds.length) {
                element.children = element.children.filter(
                    (params) => !groupIds.includes(params.group.id)
                );
                this.recursiveFilterAccountOverlay(this.parentOverlay);
            }
        }
    }
    prepareClimateOverlays() {
        return ObjectUtils.clone(
            this
                .filterAccountOverlays
        );
        // .filter(
        //     (params) =>
        //         ![
        //             "Risk Maps",
        //         ].includes(
        //             params.group
        //                 .name
        //         )
        // )
    }

    /**
     * ⭐ NEW: Get prepared climate data with caching for performance
     * Processes climate overlays once and reuses across all ranking reports
     * This prevents redundant processing when multiple ranking reports render (5+ reports)
     */
    private getPreparedClimateData(): TreeStructure[] {
        if (!this.preparedClimateDataCache) {
            const climateOverlays = this.prepareClimateOverlays();
            if (climateOverlays && climateOverlays.length > 0) {
                // Process once with single-pass filtering
                this.preparedClimateDataCache = new Datapoints().prepareClimateData(
                    climateOverlays,
                    false,  // isProjectedCall
                    false,  // checkGeometryTypeComplexOnly
                    true,   // isPointOverlayRequired
                    true    // filterByClimateChange - filter climate change overlays only
                );
            } else {
                this.preparedClimateDataCache = [];
            }
        }
        return this.preparedClimateDataCache;
    }

    changeComparisonMode() {
        // ⭐ NEW: Clear cache when mode changes
        this.preparedClimateDataCache = null;

        this.analyticData = [];
        this.analyticsColumnOne = [];
        this.analyticsColumnTwo = [];
        this.analyticsColumnThree = [];
        this.analyticData = [];

        this.isComparisonModeActivated = !this.isComparisonModeActivated;
        this.getAnalyticsFromServer();
    }

    getTooltipForComparisonToggle() {
        return !this.isComparisonModeActivated
            ? "Activate comparison mode"
            : "Deactivate comparison mode";
    }

    getActiveDasboardType(){
        return !this.isComparisonModeActivated ? WorkspaceItemType.DASHBOARD : WorkspaceItemType.ANALYTICS_DASHBOARD_COMPARISON;
    }

    extractChildrenOnly(nodes: any[]): Group[] {
        let groups: Group[] = [];

        const extract = (nodes: any[]) => {
            for (const node of nodes) {
                if (!node?.children?.length) {
                    groups.push({ ...node.value, isChecked: false });
                } else {
                    extract(node.children);
                }
            }
        };

        extract(nodes);
        return groups;
    }

    getFormattedName(name, isLengthChecked: boolean = true) {
        return AnalyticsUtils.getFormattedName(name, isLengthChecked);
    }

    onCheckboxChange(event: MatCheckboxChange, type: string, data: any) {
        const result = AnalyticsUtils.groupSelectionEvent(event, type, data._compareGroups, data._withGroups);
        data._compareGroups = result.compareGroups;
        data._withGroups = result.withGroups;
    }

    toggleItemExpansion(item: TreeNode) {
        item.expanded = !item.expanded;
    }

    toggleItem(event: MatCheckboxChange, item: TreeNode, section: 'compare' | 'with', data: any) {
        if(event.checked && section == 'compare') {
            this.compareGroupCheckEvent(data._withGroupsStrcuture, item.id, 'with');
            this.compareGroupCheckEvent(data._compareGroupsStrcuture, item.id, 'compare');
        } else if(event.checked && section == 'with') {
            this.withGroupCheckEvent(data._compareGroupsStrcuture, item.id, 'compare');
            this.withGroupCheckEvent(data._withGroupsStrcuture, item.id, 'with');
        } else if(!event.checked && section == 'compare') {
            let selectedItem = AnalyticsUtils.getSelectedNodes(data._withGroupsStrcuture);
            const withItem = selectedItem.length > 0 ? selectedItem[0] : undefined;
            this.compareGroupUnCheckEvent(data._withGroupsStrcuture, item.id, 'with', withItem);
            this.compareGroupUnCheckEvent(data._compareGroupsStrcuture, item.id, 'compare', withItem);
        } else if(!event.checked && section == 'with') {
            let selectedItem = AnalyticsUtils.getSelectedNodes(data._compareGroupsStrcuture);
            const compareItem = selectedItem.length > 0 ? selectedItem[0] : undefined;
            this.withGroupUnCheckEvent(data._compareGroupsStrcuture, item.id, 'compare', compareItem);
            this.withGroupUnCheckEvent(data._withGroupsStrcuture, item.id, 'with', compareItem);
        }
    }

    compareGroupCheckEvent(nodes: TreeNode[], id: number, section: string) {
        for (const node of nodes) {
            if ((section === 'compare' && node.id !== id) || (section === 'with' && node.id == id)) {
                node.disabled = true;
            }
            if (node.children) {
                this.compareGroupCheckEvent(node.children, id, section);
            }
        }
    }

    withGroupCheckEvent(nodes: TreeNode[], id: number, section: string) {
        for (const node of nodes) {
            if ((section === 'compare' && node.id === id) || (section === 'with' && node.id !== id)) {
                node.disabled = true;
            }
            if (node.children) {
                this.withGroupCheckEvent(node.children, id, section);
            }
        }
    }

    compareGroupUnCheckEvent(nodes: TreeNode[], id: number, section: string, withItem: any) {
        for (const node of nodes) {
            if ((section === 'with' && node.id == id) && withItem == undefined) {
                node.disabled = false;
            } else if (section === 'compare' && (withItem !== undefined && (node.id !== withItem.id && node.id !== id) ||  withItem == undefined)) {
                node.disabled = false;
            } else if (section === 'compare' && withItem == undefined) {
                node.disabled = false;
            }
            if (node.children) {
                this.compareGroupUnCheckEvent(node.children, id, section, withItem);
            }
        }
    }

    withGroupUnCheckEvent(nodes: TreeNode[], id: number, section: string, compareItem: any) {
        for (const node of nodes) {
            if ((section === 'compare' && node.id == id) && compareItem == undefined) {
                node.disabled = false;
            } else if (section === 'with' && (compareItem !== undefined && (node.id !== compareItem.id && node.id !== id) ||  compareItem == undefined)) {
                node.disabled = false;
            } else if (section === 'with' && compareItem == undefined) {
                node.disabled = false;
            }
            if (node.children) {
                this.withGroupUnCheckEvent(node.children, id, section, compareItem);
            }
        }
    }
}
